import React, { useState, useEffect, useRef, useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { useGlobalContext } from "../Config";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import {calculateSubtotal,formatDatesIfNeeded,calculateTarifaMensualWithMetraje,calculateTarifaMensualServicios,calculateTarifaMensualServiciosUnicos,sortDataByProductAndSubProduct,} from "../utilities/Helper";
import { ejecutarCierreContrato } from "../utilities/cerrarContratoUtils";
import moment from "moment";
import "moment/locale/es";
import CotizacionActions from "../components/CotizacionActions";
import FormCrearCliente from "../components/FormCrearCliente";
import ResumenMensualDialog from "../components/ResumenMensualDialog";
import RenovarAsignacionDialog from "../components/RenovarAsignacionDialog";
import ArriendoDataTable from "../components/ArriendoDataTable";
import ServiciosDataTable from "../components/ServiciosDataTable";
import ServiciosUnicosDataTable from "../components/ServiciosUnicosDataTable";

const cantidadDiasAvisoContrato = [{ label: "15 días", value: 15 },{ label: "30 días", value: 30 },{ label: "45 días", value: 45 },{ label: "60 días (recomendado)", value: 60 },{ label: "90 días", value: 90 },];
const cantidadDiasFirmaContrato = [ { label: "5 días (rápido)", value: 5 }, { label: "15 días (recomendado)", value: 15 }, { label: "30 días", value: 30 }, { label: "45 días", value: 45 }, { label: "60 días", value: 60 }, { label: "90 días", value: 90 },];

const dateFormats = ["DD/MM/YYYY","MM/DD/YYYY","YYYY/MM/DD","YYYY-MM-DD","DD-MM-YYYY","MM-DD-YYYY","DD MMM YYYY","MMM DD, YYYY","MMMM DD, YYYY","YYYY MMM DD",];

const RevisarCotizacion = (props) => {
  const { baseUrl, urlContratos } = useGlobalContext();
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const [carro, setCarro] = useState([]); // Almacena los elementos seleccionados en el carrito
  const [selectedItemsParam, setSelectedItemsParams] = useState(null); // Almacena los parámetros codificados de los ítems seleccionados
  const [cotizacion, setCotizacion] = useState(null); // Almacena los datos de la cotización

  const buildDetalleCotizacionUrl = (idCotizacion) => {return `${baseUrl}getDetalleCotizacionByIdCotizacion?idCotizacion=${idCotizacion}`;};  // Construye la URL para obtener los detalles de la cotización por ID
  const getDetalleData = async (idCot = idCotizacion) => {
    try {
      const detalleCotizacionUrl = buildDetalleCotizacionUrl(idCot);
      const data = await fetchData(detalleCotizacionUrl);

      if (data.mensaje === "OK") {
        const detalles = data.detalles;
        const productosMap = {};
        detalles.forEach((d) => {
          if (d.relacion === "producto") {
            productosMap[d.descripcion] = d;
          }
        });
        const enrichedDetalles = detalles.map((d) => {
          if (d.relacion === "subproducto") {
            const parts = String(d.descripcion).split(" - ");
            const prodDesc = parts.length > 1 ? parts[1] : null;
            const prod = prodDesc ? productosMap[prodDesc] : null;
            if (prod) {
              return { ...d, id_elemento_producto: prod.id_elemento };
            }
          }
          return d;
        });
        const encodedParams = enrichedDetalles
          .map((item) => {
            const { ...rest } = item;
            return encodeURIComponent(JSON.stringify(rest));
          })
          .join(",");
        setSelectedItemsParams(encodedParams);
        setDetallesCobro(enrichedDetalles);
      } else {
        alert(data.mensaje);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const buildCotizacionData = (idCotizacion) => {
    return `${baseUrl}getCotizacionById?idCotizacion=${idCotizacion}`;
  };

  const getCotizacionData = async (idCot = idCotizacion) => {
    try {
      const cotizacionUrl = buildCotizacionData(idCot);
      const data = await fetchData(cotizacionUrl);

      if (data.mensaje === "OK") {
        setCotizacion(data.cotizacion);
      } else {
        alert(data.mensaje);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [diasAviso, setDiasAviso] = useState(60);// Estado para el número de días de aviso antes de cerrar el contrato
  const [diasFirma, setDiasFirma] = useState(15);// Estado para el número de días de firma del contrato

  const [subtotalServicios, setSubtotalServicios] = useState(0); // Estado para almacenar el subtotal de servicios en la cotización
  const [showCerrarContrato, setShowCerrarContrato] = useState(false);

  const [desde, setDesde] = useState(searchParams.get("desde")); // Extrae las fechas "desde" y "hasta" de la URL
  const [hasta, setHasta] = useState(searchParams.get("hasta"));
  const [cliente, setCliente] = useState(null);  // Estado para almacenar la información del cliente
  const [loading, setLoading] = useState(false); // Estado para manejar la carga de datos
  const [loadingAsig, setLoadingAsig] = useState(false); // Estado para manejar la carga de datos
  const [flattenedDataArriendo, setFlattenedDataArriendo] = useState([]); // Datos de arriendo en un formato aplanado
  const [serviciosUnicos, setServiciosUnicos] = useState([]); // Lista de servicios únicos en la cotización
  const [tramoCounter, setTramoCounter] = useState(0);  // Estado para contar el número de tramos en la cotización
  const [itemsPorEliminar, setItemsPorEliminar] = useState([]);
  const [monedaOptionsFetched, setMonedaOptionsFetched] = useState(false);  // Estado para indicar si las opciones de moneda ya fueron obtenidas
  const [maxAmountOfCuotas, setMaxAmountOfCuotas] = useState(0);  // Estado para manejar el número máximo de cuotas permitidas
  const [cuotas, setCuotas] = useState(0);// Estado para manejar la cantidad de cuotas seleccionadas
  const [itemCuotas, setItemCuotas] = useState(null);// Estado para almacenar los ítems asociados a cuotas
  const [showTramoModalArriendo, setShowTramoModalArriendo] = useState(false);// Estado para mostrar el modal de tramo de arriendo
  const [detallesCobro, setDetallesCobro] = useState([]);
  const toast = useRef(null);
  const [showDialog, setShowDialog] = useState(false);
  const [empresas, setEmpresas] = useState([{ name: "TODAS", value: "TODAS" },{ name: "ALTAMIRA", value: "Altamira" },{ name: "LA SIEMBRA", value: "LA SIEMBRA" },]);
  const [showProductForm2, setshowProductForm2] = useState(false);
  const [showRechazarDialog, setShowRechazarDialog] = useState(false);
  const [showVencimientoDialog, setShowVencimientoDialog] = useState(false);
  const [showRenovarDialog, setShowRenovarDialog] = useState(false);
  const [observacion, setObservacion] = useState("");
  const motivosRechazo = [{ label: "especificación tecnica", value: "especificacion tecnica" },{ label: "fidelización comercial", value: "fidelizacion comercial" },{ label: "fidelización logistica", value: "fidelizacion logistica" },{ label: "linea de credito", value: "linea de credito" },{ label: "plazo de entrega", value: "plazo de entrega" },{ label: "plazo de pago", value: "plazo de pago" },{ label: "precio(s)", value: "precio(s)" },{ label: "servicios", value: "servicios" },{ label: "stock disponible", value: "stock disponible" },{ label: "obra detenida", value: "obra detenida" }];
  const motivosRenovacion = [{ label: "Buen cumplimiento", value: "Buen cumplimiento" },{ label: "Continuidad de uso", value: "Continuidad de uso" },{ label: "Conveniencia mutua", value: "conveniencia mutua" },{ label: "Mismo acuerdo previo", value: "Mismo acuerdo previo" },{ label: "Ajuste por IPC", value: "Ajuste por IPC" },{ label: "Buena relación", value: "Buena relación" },{ label: "Sin cambio de uso", value: "Sin cambio de uso" },{ label: "Por solicitud del arrendatario", value: "Por solicitud del arrendatario" },{ label: "Mantener arrendatario", value: "Mantener arrendatario" },{ label: "Extensión temporal", value: "Extensión temporal" }];
  const [fechaVencimiento, setFechaVencimiento] = useState(null);
  const [observacionRenovacion, setObservacionRenovacion] = useState("");
  const [hastaRenovacion, setHastaRenovacion] = useState(null);
  useEffect(() => {
      if (hasta && !hastaRenovacion) {
          const primerDisponible = moment(hasta, "YYYY-MM-DD", true).add(1, "day").startOf("day").toDate();
          setHastaRenovacion(primerDisponible);
      }
  }, [hasta, hastaRenovacion]);
  // --------------------------------------
  // Funciones de obtención de datos
  // --------------------------------------
  useEffect(() => {
    fetchMonedaOptions(); // Obtiene las opciones de moneda disponibles
    getDetalleData(); // Obtiene los detalles de la cotización
    getCotizacionData(); // Obtiene los datos de la cotización
    fetchDataCliente(); // Obtiene los datos del cliente
  }, []);

  // Re-cargar datos cuando cambien los parámetros de la URL
  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const newIdCliente = parseInt(sp.get("idCliente"));
    const newIdCotizacion = parseInt(sp.get("idCotizacion"));
    const newDesde = sp.get("desde");
    const newHasta = sp.get("hasta");

    if (typeof newDesde !== "undefined") setDesde(newDesde);
    if (typeof newHasta !== "undefined") setHasta(newHasta);

    if (!isNaN(newIdCotizacion)) {
      getDetalleData(newIdCotizacion);
      getCotizacionData(newIdCotizacion);
    }
    if (!isNaN(newIdCliente)) {
      fetchDataCliente(newIdCliente);
    }
  }, [location.search]);
  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };
  const fetchMonedaOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}getAllMonedas`);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setMonedaOptions(data.monedas); // Guarda las opciones de moneda en el estado
      setMonedaOptionsFetched(true); // Marca que las opciones de moneda han sido obtenidas
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const navigate = useNavigate();

  useEffect(() => {
    const estado = String(cotizacion?.estado?.estado || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

    if (estado !== "COTIZACION") {
      return;
    }

    const onPopState = () => {
      navigate("/cotizacion", { replace: true });
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [cotizacion, navigate]);

  const [showTramoModalServicio, setShowTramoModalServicio] = useState(false);
  const [showTramoModalUnico, setShowTramoModalUnico] = useState(false);
  const handleNewTramoCuota = (rowData) => {
    clearTramosVariables();
    if (rowData.tarifa_cliente <= 0) {
      alert("Debe añadir una tarifa para poder elegir cuotas");
    } else {
      setNombreCuadro(rowData.descripcion);

      // Ensure the dates are in dd/mm/yyyy format
      const startDate = moment(desde, dateFormats, true);
      const endDate = moment(hasta, dateFormats, true);

      if (!startDate.isValid() || !endDate.isValid()) {
        alert("Fechas no válidas");
        return;
      }

      const diffInMonths = endDate.diff(startDate, "months");

      // Set maxAmountOfCuotas with the number of months
      setMaxAmountOfCuotas(diffInMonths + 1);
      setShowTramoModalUnico(true);
      setCuotas(0);
      setItemCuotas(rowData);
    }
  };
  const handleNewTramoServicio = (rowData) => {
    clearTramosVariables();
    setNombreCuadro(rowData.descripcion);

    // Parse dates using moment
    const desdeDate = moment(rowData.desde, dateFormats, true).toDate();
    const hastaDate = moment(rowData.hasta, dateFormats, true).toDate();

    if (
      !moment(rowData.desde, dateFormats, true).isValid() ||
      !moment(rowData.hasta, dateFormats, true).isValid()
    ) {
      alert("Fechas no válidas");
      return;
    }

    const tramo1 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };
    const tramo2 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };

    // No need to adjust for timezone offset since moment handles it properly

    setHastaTramoGeneral(hastaDate);
    setTramos([tramo1, tramo2]);

    setShowTramoModalServicio(true);
  };
  const [servicios, setServicios] = useState([]);
  const [subtotalArriendo, setSubtotalArriendo] = useState(0);

    
  // --------------------------------------
  // Efectos de las modificaciones de items 
  // --------------------------------------
  useEffect(() => {
    if (selectedItemsParam) {
      try {
        const decodedParam = decodeURIComponent(selectedItemsParam);

        if (decodedParam.startsWith("[")) {
          const selectedItems = JSON.parse(decodedParam);
          setCarro(selectedItems);
        } else {
          const selectedItems = JSON.parse(`[${decodedParam}]`);

          setCarro(selectedItems);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [selectedItemsParam]);

  useEffect(() => {
    if (carro.length > 0) {
      // Se crean arreglos vacíos para almacenar los diferentes tipos de elementos dentro de "carro"
      const serviciosInside = []; // Almacena servicios que no son "Habilitacion Fibra" ni "Obra Civil"
      const subproductosInside = []; // Almacena subproductos
      const serviciosUnicosInside = []; // Almacena servicios únicos como "Habilitacion Fibra" u "Obra Civil"
      const flattenedDataArriendoInside = []; // Almacena productos de tipo "arriendo"

      // Se recorre el array "carro" para clasificar los elementos según su tipo de relación
      carro.forEach((item) => {
        if (item.relacion === "subproducto") {
          subproductosInside.push(item); // Agrega los subproductos al array correspondiente
        } else if (item.relacion === "producto") {
          flattenedDataArriendoInside.push(item); // Agrega los productos de tipo arriendo
        } else if (item.relacion === "servicio") {
          // Se excluyen los servicios de "Habilitacion Fibra" y "Obra Civil"
          if ( !(item.descripcion.includes("Habilitacion Fibra") || item.descripcion.includes("Obra Civil"))){
            // Si el servicio es "Agua" o "Electricidad", se marca con la propiedad "remarcador"
            if (
              item.descripcion.includes("Agua") ||
              item.descripcion.includes("Electricidad")
            ) {
              item.remarcador = true;
              serviciosInside.push(item);
            } else {
              item.remarcador = false;
              serviciosInside.push(item);
            }
          } else {
            // Si es "Habilitacion Fibra" u "Obra Civil", se agrega a "serviciosUnicosInside"
            serviciosUnicosInside.push(item);
          }
        }
      });

      // Los subproductos se añaden al array de productos de arriendo
      subproductosInside.forEach((subprod) => {
        flattenedDataArriendoInside.push(subprod);
      });

      // Función para agrupar elementos por "descripcion"
      const groupByDescripcion = (arr) => {
        const groups = arr.reduce((acc, item) => {
          if (!acc[item.descripcion]) {
            acc[item.descripcion] = [];
          }
          acc[item.descripcion].push(item);
          return acc;
        }, {});

        return Object.values(groups); // Devuelve un array con los grupos formados
      };

      // Función para ordenar por fecha ascendente según la propiedad "desde"
      const sortByDate = (a, b) =>
        moment(a.desde, dateFormats, true).toDate() -
        moment(b.desde, dateFormats, true).toDate();

      // Función para ordenar los grupos por fecha y aplanar el array en una sola lista
      const mergeSortedGroups = (groups) => {
        return groups.map((group) => group.sort(sortByDate)).flat();
      };

      // Se separan y ordenan los servicios únicos agrupándolos por descripción y dividiendo en "splittable" y "unsplittable"
      const sortedServiciosUnicos = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(serviciosUnicosInside)),
        ...groupByDescripcion(splittable(serviciosUnicosInside)),
      ]);

      // Se ordenan los productos de arriendo aplicando la misma lógica
      const sortedFlattenedDataArriendo = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(flattenedDataArriendoInside)),
        ...groupByDescripcion(splittable(flattenedDataArriendoInside)),
      ]);

      const groupedArriendoData = sortedFlattenedDataArriendo;

      // Se ordenan los servicios normales aplicando la misma lógica
      const sortedServicios = mergeSortedGroups([
        ...groupByDescripcion(unsplittable(serviciosInside)),
        ...groupByDescripcion(splittable(serviciosInside)),
      ]);

      const groupedServiciosData = sortedServicios;

      // Antes: let finalServiciosUnicos = sortDataByProductAndSubProduct(groupedServiciosUnicosData);
      let finalServiciosUnicos = sortDataByProductAndSubProduct(sortedServiciosUnicos);

      // Si existen elementos que correspondan a cuotas, se reordena numéricamente según el número extraído
      if (finalServiciosUnicos.some(item => item.tramo && item.tramo.toLowerCase().includes("cuota"))) {
        finalServiciosUnicos.sort((a, b) => {
          const extractCuotaNumber = (str) => {
            if (!str) return 0;
            const trimmedStr = str.trim();
            const regex = /Cuota\s+(\d+)/i;
            const match = trimmedStr.match(regex);
            return match ? parseInt(match[1], 10) : 0;
          };
          return extractCuotaNumber(a.tramo) - extractCuotaNumber(b.tramo);
        });
      }

      // Se actualizan los estados con los datos ordenados y agrupados correctamente
      setServiciosUnicos(sortDataByProductAndSubProduct(finalServiciosUnicos));
      setFlattenedDataArriendo(sortDataByProductAndSubProduct(groupedArriendoData));
      setServicios(sortDataByProductAndSubProduct(groupedServiciosData));

    }
  }, [carro]); // Se ejecuta cada vez que "carro" cambia

  // --------------------------------------
  // Manejo de tramos y cuotas
  // --------------------------------------
  const unsplittable = (arr) =>
    arr.filter((item) => !item.descripcion.includes(" - "));
  const splittable = (arr) =>
    arr.filter((item) => item.descripcion.includes(" - "));
  const [tramos, setTramos] = useState([]);
  const [nombreCuadro, setNombreCuadro] = useState("");
  const [hastaTramoGeneral, setHastaTramoGeneral] = useState(null);
  const [tarifaTramo, setTarifaTramo] = useState(0);
  const [monedaOptions, setMonedaOptions] = useState([]);

  const handleTramoConfirmationArriendo = async (descripcion) => {
    if (loading) return;
    setLoading(true);

    const duplicateTramos = tramos.filter(
      (tramo, index) =>
        tramo.descripcion === descripcion &&
        tramos.findIndex(
          (t, i) =>
            i !== index &&
            t.descripcion === descripcion &&
            moment(t.desde).isSame(moment(tramo.desde)) &&
            moment(t.hasta).isSame(moment(tramo.hasta))
        ) !== -1
    );

    if (duplicateTramos.length > 0) {
      alert("Error: Los tramos no pueden tener la misma fecha de inicio y término");
      setLoading(false);
      return;
    }

    const flattenedDataArriendoCopy = [...flattenedDataArriendo];
    const serviciosArrayCopy = [...servicios];

    const indexToRemoveArriendo = flattenedDataArriendoCopy.findIndex(
      (item) => item.descripcion === descripcion
    );

    const indexToRemoveServicios = serviciosArrayCopy.findIndex(
      (item) =>
        item.descripcion.includes(descripcion) &&
        item.descripcion.includes("Gasto Comun")
    );

    const gastoComunItem = serviciosArrayCopy.find(
      (item) =>
        item.descripcion.includes(descripcion) &&
        item.descripcion.includes("Gasto Comun")
    );

    if (indexToRemoveArriendo !== -1) {
      const itemToRemove = flattenedDataArriendoCopy[indexToRemoveArriendo];
      await deactivateItem(itemToRemove);
      flattenedDataArriendoCopy.splice(indexToRemoveArriendo, 1);
      flattenedDataArriendoCopy.push(...tramos);

      const matchingItems = flattenedDataArriendoCopy.filter(
        (item) => item.descripcion === descripcion
      );

      matchingItems.forEach((item, index) => {
        item.tramo = `Tramo ${index + 1}`;
        item.id = null;
      });

      flattenedDataArriendoCopy.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }
        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });

      const formattedAllItems = flattenedDataArriendoCopy.map((item) =>
        formatDatesIfNeeded(item, false)
      );
      await Promise.all(formattedAllItems.map(postDataCotizacion));
    }

    if (indexToRemoveServicios !== -1) {
      const itemToRemove = serviciosArrayCopy[indexToRemoveServicios];
      await deactivateItem(itemToRemove);
      serviciosArrayCopy.splice(indexToRemoveServicios, 1);
      // Add new tramos for Gasto Comun in serviciosArrayCopy

      tramos.forEach((tramo, index) => {
        serviciosArrayCopy.push({
          ...gastoComunItem,
          desde: tramo.desde,
          hasta: tramo.hasta,
          tramo: `Tramo ${index + 1}`,
          id: null,
        });
      });

      serviciosArrayCopy.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }
        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });
      const formattedAllItems = serviciosArrayCopy.map((item) =>
        formatDatesIfNeeded(item, false)
      );
      await Promise.all(formattedAllItems.map(postDataCotizacion));
    }
    setShowTramoModalArriendo(false);
    await getDetalleData();
    setLoading(false);
  };


  // ---------------------------- 
  // Funcion de ordenamiento y calculo de cuotas
  //---------------------------- 
  const handleTramoConfirmacionCuota = async (rowData) => {
    if (loading) return;
    if (maxAmountOfCuotas === 1) {
      alert(
        "Si solo hay un mes o menos en el periodo no es posible pagar en cuotas"
      );
    }
    setLoading(true);
    let cuotasInside = cuotas;
    // Ensure the dates are in dd/mm/yyyy format

    if (cuotasInside > maxAmountOfCuotas) {
      cuotasInside = maxAmountOfCuotas;
    }

    const serviciosUnicosCopy = [...serviciosUnicos];
    const itemBeforeRemove = serviciosUnicosCopy.find(
      (item) => item.descripcion === rowData.descripcion
    );
    const indexToRemove = serviciosUnicosCopy.findIndex(
      (item) => item.descripcion === rowData.descripcion
    );

    if (indexToRemove !== -1) {
      const itemToRemove = serviciosUnicosCopy[indexToRemove];
      await deactivateItem(itemToRemove);
      serviciosUnicosCopy.splice(indexToRemove, 1);

      // Calculate the number of months between desde and hasta
      const startDate = moment(rowData.desde, dateFormats, true).toDate();
      const endDate = moment(rowData.hasta, dateFormats, true).toDate();
      const tarifaCliente = rowData.tarifa_cliente;
      const totalDays = Math.ceil(
        (endDate - startDate) / (1000 * 60 * 60 * 24)
      );

      const daysPerCuota = Math.ceil(totalDays / cuotasInside);

      let currentStartDate = moment(startDate, dateFormats, true).toDate();

      for (let i = 0; i < cuotasInside; i++) {
        const newItem = { ...itemBeforeRemove };
        const daysToAdd =
          i === cuotasInside - 1 ? totalDays - daysPerCuota * i : daysPerCuota;

        const perCuota = (parseFloat(tarifaCliente) || 0) / cuotasInside;
        newItem.tarifa_cliente = (perCuota).toFixed(2);
        newItem.tramo = `Cuota ${i + 1}`;
        newItem.id = null;
        serviciosUnicosCopy.push(newItem);
        currentStartDate = moment(currentStartDate)
          .add(daysToAdd, "days")
          .toDate();
      }

      // ORDENAR LOS SERVICIOS UNICOS POR DESDE
      const formattedAllItems = serviciosUnicosCopy.map((item) =>
        formatDatesIfNeeded(item, false)
      );
      await Promise.all(formattedAllItems.map(postDataCotizacion));
    }
    setShowTramoModalUnico(false);
    await getDetalleData();
    setLoading(false);
  };
  const clearTramosVariables = () => {
    setTramos([]);
    setTramoCounter(0);
  };
  const handleNewTramoArriendo = (rowData) => {
    // Limpia las variables relacionadas con los tramos antes de crear uno nuevo
    clearTramosVariables();

    // Establece el nombre del cuadro con la descripción del rowData
    setNombreCuadro(rowData.descripcion);

    // Convierte las fechas de "desde" y "hasta" a objetos Date utilizando moment
    const desdeDate = moment(rowData.desde, dateFormats, true).toDate();
    const hastaDate = moment(rowData.hasta, dateFormats, true).toDate();

    // Valida si las fechas son correctas, si no, muestra una alerta y detiene la ejecución
    if (
      !moment(rowData.desde, dateFormats, true).isValid() ||
      !moment(rowData.hasta, dateFormats, true).isValid()
    ) {
      alert("Fechas no válidas");
      return;
    }

    // Se crean dos objetos de tramo con las mismas fechas de inicio y fin
    const tramo1 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };
    const tramo2 = {
      ...rowData,
      desde: desdeDate,
      hasta: hastaDate,
    };

    // Convierte las fechas de tramo1 y tramo2 en objetos moment para su posterior manipulación
    tramo1.desde = moment(tramo1.desde, dateFormats, true);
    tramo1.hasta = moment(tramo1.hasta, dateFormats, true);

    tramo2.desde = moment(tramo2.desde, dateFormats, true);
    tramo2.hasta = moment(tramo2.hasta, dateFormats, true);

    // Establece la fecha de "hasta" general para el tramo
    setHastaTramoGeneral(hastaDate);

    // Guarda la tarifa base del tramo en el estado
    setTarifaTramo(rowData.tarifa_base);

    // Guarda los tramos creados en el estado
    setTramos([tramo1, tramo2]);

    // Muestra el modal para la configuración del tramo de arriendo
    setShowTramoModalArriendo(true);
  };

  /**
   * Filtra un array eliminando un elemento específico
   * @param {Array} array - El array a filtrar
   * @param {Object} rowData - El elemento que no queremos incluir en el resultado
   * @return {Array} Un nuevo array sin el elemento especificado
   */
  const filterArray = (array, rowData) => {
    return array.filter((data) => data !== rowData);
  };

  /**
   * Formatea una fecha a "YYYY-MM-DD"
   * @param {string|Date} dateInput - La fecha de entrada en distintos formatos
   * @return {string} La fecha formateada en "YYYY-MM-DD" o muestra una alerta si el formato es inválido
   */
  function formatDateTramo(dateInput) {
    // Intenta convertir la fecha con los formatos permitidos
    const date = moment(dateInput, dateFormats, true);

    if (!date.isValid()) {
      alert("Fecha en formato inválido");
      return;
    }

    return date.format("YYYY-MM-DD");
  }

  /**
   * Actualiza un tramo si es necesario
   * @param {Array} array - El array de elementos con tramos
   * @param {Object} rowData - El elemento que se quiere actualizar
   * @return {Array} Un nuevo array con el tramo actualizado si corresponde
   */
  const updateTramoIfNeeded = (array, rowData) => {
    // Filtra los elementos que coinciden con la descripción del rowData
    const newArray = array.filter(
      (item) => item.descripcion === rowData.descripcion
    );

    if (newArray.length > 0) {
      // Se crea un nuevo objeto con el tramo actualizado
      const updatedItem = {
        ...newArray[0],
        tramo: "", // Se vacía el campo tramo
        desde: formatDateTramo(desde), // Se actualiza la fecha de inicio
        hasta: formatDateTramo(hasta), // Se actualiza la fecha de fin
        tarifa_cliente: newArray[0].tarifa_base, // Se asigna la tarifa base como tarifa del cliente
        descuento: 0, // Se reinicia el descuento a 0
      };

      // Se filtran los elementos que tienen la misma descripción para reemplazar el anterior
      const updatedArray = array.filter(
        (item) => item.descripcion !== rowData.descripcion
      );

      // Se añade el elemento actualizado al array
      updatedArray.push(updatedItem);

      return updatedArray;
    }

    return array; // Si no hay cambios, se devuelve el mismo array original
  };

  // Funcion para borrar lineas
  const handleBorrarLinea = async (itemABorrar, nombreArray) => {
    if (loading) return; // Si ya está en proceso de carga, se detiene la ejecución
    setLoading(true); // Se activa el estado de carga
    console.log("[handleBorrarLinea] inicio", { nombreArray, id: itemABorrar?.id, descripcion: itemABorrar?.descripcion });

    let arrayToMaintain; // Array que almacenará los elementos que se deben mantener después del borrado
    let hasTramo =
      itemABorrar.tramo !== "" &&
      itemABorrar.tramo !== null &&
      itemABorrar.tramo !== undefined &&
      itemABorrar.tramo !== "null"; // Verifica si el item tiene un tramo definido

    let itemsToDelete = []; // Array que almacenará los elementos a eliminar

    // Si el ítem tiene tramos, se muestra una confirmación antes de eliminar
    if (hasTramo) {
      const confirmDelete = window.confirm(
        "El borrado de un item con tramos hará que todos los tramos se borren y vuelva a su estado original"
      );
      if (!confirmDelete) {
        setLoading(false);
        return;
      }
    }

    // Se determina qué tipo de elemento se va a eliminar según el nombre del array
    switch (nombreArray) {
      case "productos":
        // Filtra los productos que no tienen guion en la descripción
        const itemsWithoutHyphen = flattenedDataArriendo.filter(
          (item) => !item.descripcion.includes(" - ")
        );
        //console.log("[productos] itemsWithoutHyphen count:", itemsWithoutHyphen.length);
        // Si solo queda un producto y no tiene guion, se evita que la cotización quede vacía
        if (
          itemsWithoutHyphen.length === 1 &&
          !itemABorrar.descripcion.includes(" - ")
        ) {
          alert("No puede dejar la cotización sin producto");
          setLoading(false);
          return;
        } else {
          const originalArray = [...flattenedDataArriendo]; // Se mantiene el array original
          //console.log("[productos] originalArray count:", originalArray.length);

          // Si el ítem tiene tramos, se actualiza el tramo en lugar de eliminar directamente
          if (hasTramo) {
            arrayToMaintain = updateTramoIfNeeded(
              flattenedDataArriendo,
              itemABorrar
            );
          //console.log("[productos] updateTramoIfNeeded -> arrayToMaintain count:", arrayToMaintain.length);
          } else {
            arrayToMaintain = filterArray(flattenedDataArriendo, itemABorrar);
          //console.log("[productos] filterArray -> arrayToMaintain count:", arrayToMaintain.length);
          }

          // Se registran los ítems eliminados comparando el array original con el modificado
          if (originalArray.length > 0) {
            const deletedItems = originalArray.filter(
              (item) => !arrayToMaintain.includes(item)
            );
            deletedItems.forEach((item) => itemsToDelete.push(item));
            //console.log("[productos] deletedItems count:", deletedItems.length, deletedItems);
          }

          // Se verifica si el ítem sigue presente en el array luego de la eliminación
          const itemSecondPart = itemABorrar.descripcion;
          const itemStillPresent = arrayToMaintain.some(
            (item) => item.descripcion === itemABorrar.descripcion
          );
          //console.log("[productos] itemStillPresent:", itemStillPresent);

          // Si el ítem ya no está presente, se eliminan los relacionados en otros arrays
          if (!itemStillPresent) {
            const relatedServicios = servicios.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedServicios count:", relatedServicios.length, relatedServicios);
            relatedServicios.forEach((item) => itemsToDelete.push(item));

            const relatedServiciosUnicos = serviciosUnicos.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedServiciosUnicos count:", relatedServiciosUnicos.length, relatedServiciosUnicos);
            relatedServiciosUnicos.forEach((item) => itemsToDelete.push(item));

            const relatedFlattenedDataArriendo = flattenedDataArriendo.filter(
              (item) => item.descripcion.split(" - ")[1] === itemSecondPart
            );
            //console.log("[productos] relatedFlattenedDataArriendo count:", relatedFlattenedDataArriendo.length, relatedFlattenedDataArriendo);
            relatedFlattenedDataArriendo.forEach((item) =>
              itemsToDelete.push(item)
            );

            // Se eliminan del array los elementos que están en la lista de eliminación
            arrayToMaintain = arrayToMaintain.filter(
              (item) =>
                !itemsToDelete.some(
                  (deletedItem) => deletedItem.descripcion === item.descripcion
                )
            );
          } else {
            // Manejo especial para los "Gasto Comun" en los servicios
            const gastoComunItems = servicios.filter(
              (item) =>
                item.descripcion.includes("Gasto Comun") &&
                item.descripcion.split(" - ")[1] === itemABorrar.descripcion
            );
            //console.log("[productos] gastoComunItems count:", gastoComunItems.length, gastoComunItems);

            // Si hay más de un "Gasto Comun" con tramo, se actualiza en vez de eliminar
            if (gastoComunItems.length > 1 && hasTramo) {
              const updatedGastoComunItem = {
                ...gastoComunItems[0],
                tramo: "",
                desde: formatDateTramo(desde),
                hasta: formatDateTramo(hasta),
                id: null,
              };
              //console.log("[productos] updatedGastoComunItem:", updatedGastoComunItem);
              const updatedServicios = servicios.filter(
                (item) =>
                  !(
                    item.descripcion.includes("Gasto Comun") &&
                    item.descripcion.split(" - ")[1] === itemABorrar.descripcion
                  )
              );
              //console.log("[productos] updatedServicios count:", updatedServicios.length, updatedServicios);
              arrayToMaintain.push(updatedGastoComunItem);
              //console.log("[productos] arrayToMaintain count:", arrayToMaintain.length, arrayToMaintain);

              if (servicios.length > 0) {
                const originalServicios = [...servicios];
                const deletedServiciosItems = originalServicios.filter(
                  (item) => !updatedServicios.includes(item)
                );
                deletedServiciosItems.forEach((item) =>
                  itemsToDelete.push(item)
                );
                //console.log("[productos] deletedServiciosItems count:", deletedServiciosItems.length, deletedServiciosItems);
              }
            }
          }

          // Eliminación de elementos relacionados con "Obra Civil" si no hay adicionales
          const newArray = arrayToMaintain.filter(
            (item) =>
              item.tipo === "Adicional" &&
              item.descripcion.split(" - ")[1] ===
                itemABorrar.descripcion.split(" - ")[1]
          );
          //console.log("[productos] newArray count:", newArray.length, newArray);

          if (newArray.length < 1) {
            const relatedObraCivilItems = serviciosUnicos.filter(
              (item) =>
                item.descripcion.includes("Obra Civil") &&
                item.descripcion.split(" - ")[1] ===
                  itemABorrar.descripcion.split(" - ")[1]
            );
            //console.log("[productos] relatedObraCivilItems count:", relatedObraCivilItems.length, relatedObraCivilItems);
            relatedObraCivilItems.forEach((item) => itemsToDelete.push(item));
          }
        }
        break;
      case "servicios":
        const originalServicios = [...servicios];

        if (hasTramo) {
          arrayToMaintain = updateTramoIfNeeded(servicios, itemABorrar);
        } else {
          arrayToMaintain = filterArray(servicios, itemABorrar);
        }

        if (originalServicios.length > 0) {
          const deletedItemsServicios = originalServicios.filter(
            (item) => !arrayToMaintain.includes(item)
          );
          deletedItemsServicios.forEach((item) => itemsToDelete.push(item));
        }

        const newArrayServicios = arrayToMaintain.filter(
          (item) => item.descripcion === itemABorrar.descripcion
        );

        const isInternet =
          typeof itemABorrar?.descripcion === "string" &&
          itemABorrar.descripcion.toLowerCase().includes("internet");

        if (newArrayServicios.length < 1 && isInternet) {
          const suffix = itemABorrar.descripcion.includes(" - ")
            ? itemABorrar.descripcion.split(" - ")[1]
            : null;

          // Eliminar servicios únicos del mismo sufijo NO “Habilitacion Fibra”
          const unicosMismoSufijoNoHF = (serviciosUnicos || []).filter((su) => {
            const suDesc =
              typeof su?.descripcion === "string" ? su.descripcion.toLowerCase() : "";
            if (suffix) {
              const suSuffix = su.descripcion.includes(" - ")
                ? su.descripcion.split(" - ")[1]
                : null;
              return suSuffix === suffix && !suDesc.includes("habilitacion fibra") &&
              !suDesc.includes("obra civil");
            }
            return !suDesc.includes("habilitacion fibra");
          });

          unicosMismoSufijoNoHF.forEach((item) => itemsToDelete.push(item));
        }

        // SOLO eliminar “Habilitacion Fibra” cuando el item a borrar es Internet
        if (isInternet) {
          const relatedHabilitacionFibraItems = (serviciosUnicos || []).filter(
            (item) =>
              typeof item?.descripcion === "string" &&
              item.descripcion.toLowerCase().includes("habilitacion fibra") &&
              item.descripcion.split(" - ")[1] ===
                itemABorrar.descripcion.split(" - ")[1]
          );

          relatedHabilitacionFibraItems.forEach((item) =>
            itemsToDelete.push(item)
          );
        }
        break;
      case "unicos":
        const originalUnicos = [...serviciosUnicos];

        if (hasTramo) {
          arrayToMaintain = updateTramoIfNeeded(serviciosUnicos, itemABorrar);
        } else {
          arrayToMaintain = filterArray(serviciosUnicos, itemABorrar);
        }

        if (originalUnicos.length > 0) {
          const deletedItemsUnicos = originalUnicos.filter(
            (item) => !arrayToMaintain.includes(item)
          );
          deletedItemsUnicos.forEach((item) => itemsToDelete.push(item));
        }
        // Reiniciar el estado de cuotas si se elimina una cuota
        if (itemABorrar.tramo && itemABorrar.tramo.includes("Cuota")) {
          setCuotas(0);
        }
        break;
      default:
        break;
    }
    //console.log("[productos] itemsToDelete count:", itemsToDelete.length, itemsToDelete);
    //console.log("[productos] arrayToMaintain count:", arrayToMaintain.length, arrayToMaintain);
    if (itemsToDelete.length > 0) {
      await Promise.all(itemsToDelete.map(deactivateItem));
      await Promise.all(arrayToMaintain.map(postDataCotizacion));
      //await getDetalleData();
    }

    //window.location.reload(true); // Se recarga la página para actualizar la información
    await getDetalleData();
    setLoading(false); // Se desactiva el estado de carga
  };

  // Funcion para seleccionar la fecha de tramo
  const selectFechaTramo = (index, newHasta) => {
    // Se crea una copia del array de tramos para actualizarlo sin modificar el original directamente
    let updatedTramos = [...tramos];

    // Se obtiene el tramo actual a modificar
    const currentTramo = updatedTramos[index];

    // Se convierten las fechas a objetos moment para facilitar su manipulación
    const newHastaMoment = moment(newHasta, dateFormats, true); // Nueva fecha de finalización ingresada
    const currentHastaMoment = moment(currentTramo.hasta, dateFormats, true); // Fecha de finalización actual del tramo
    const currentDesdeMoment = moment(currentTramo.desde, dateFormats, true); // Fecha de inicio actual del tramo
    const hastaTramoGeneralMoment = moment(
      hastaTramoGeneral,
      dateFormats,
      true
    ); // Fecha final general del tramo

    // Función que valida si el primer tramo es válido
    const isFirstTramoValid = () =>
      !newHastaMoment.isSame(hastaTramoGeneralMoment) && // La nueva fecha no debe ser igual a la fecha final general
      !newHastaMoment.isSame(currentHastaMoment) && // La nueva fecha no debe ser igual a la actual
      newHastaMoment.isAfter(currentDesdeMoment); // La nueva fecha debe ser posterior a la fecha de inicio del tramo

    // Función que valida si el último tramo es válido
    const isLastTramoValid = () =>
      tramoCounter === tramos.length - 1 && // Se verifica si es el último tramo
      newHastaMoment.isBefore(hastaTramoGeneralMoment); // La nueva fecha debe ser anterior a la fecha final general

    // Si el índice es 0, significa que estamos modificando el primer tramo
    if (index === 0) {
      if (isFirstTramoValid()) {
        // Se obtiene el siguiente tramo
        const secondTramo = updatedTramos[index + 1];

        // Se actualiza la fecha de finalización del tramo actual
        currentTramo.hasta = newHastaMoment.toDate();

        // Se actualiza la fecha de inicio del segundo tramo al día siguiente de la nueva fecha de finalización
        secondTramo.desde = newHastaMoment.clone().add(1, "day").toDate();

        // Se actualizan los tramos con las nuevas fechas
        updatedTramos = [currentTramo, secondTramo];
        setTramos(updatedTramos);

        // Se incrementa el contador de tramos
        setTramoCounter((prevCounter) => prevCounter + 1);
      } else {
        alert("no es valido"); // Se muestra una alerta si la nueva fecha no es válida
      }
    }
    // Si no es el primer tramo, pero es el último tramo
    else if (isLastTramoValid()) {
      // Se actualiza la fecha de finalización del tramo actual
      currentTramo.hasta = newHastaMoment.toDate();

      // Se crea un nuevo tramo con las fechas ajustadas
      const newTramo = {
        ...currentTramo,
        desde: newHastaMoment.clone().add(1, "day").toDate(), // Se establece la fecha de inicio un día después de la nueva fecha
        hasta: hastaTramoGeneralMoment.toDate(), // La fecha de finalización es la fecha final general
      };

      // Se actualiza el array de tramos, reemplazando el tramo modificado
      updatedTramos = updatedTramos.map((tramo, i) =>
        i === index ? currentTramo : tramo
      );

      // Se agrega el nuevo tramo al array de tramos
      updatedTramos.push(newTramo);

      // Se incrementa el contador de tramos
      setTramoCounter((prevCounter) => prevCounter + 1);

      // Se actualiza el estado con la nueva lista de tramos
      setTramos(updatedTramos);
    }
    // Si la nueva fecha no cumple ninguna condición, se muestra una alerta
    else {
      alert("aqui termina el ciclo");
    }
  };

  const matrixData = {};
  const [resumenMensual, setResumenMensual] = useState([]);

  /**
   * Calcula los cargos mensuales en función de un conjunto de cargos y si es un servicio único.
   * @param {Array} charges - Lista de cargos a procesar.
   * @param {boolean} isUniqueService - Indica si se trata de un servicio único.
   * @return {Object} Un objeto con claves "YYYY-MM" representando meses y valores con el total acumulado por mes.
   */
  function calculateMonthlyCharges(charges, isUniqueService = false) {
    const monthlyCharges = {}; // Objeto para almacenar los cargos mensuales
    charges.forEach((charge) => {
      // Convierte las fechas "desde" y "hasta" a UTC para evitar problemas de zona horaria
      const startDateUTC = moment(charge.desde, dateFormats, true)
        .startOf("day")
        .utc();
      const endDateUTC = moment(charge.hasta, dateFormats, true)
        .startOf("day")
        .utc();

      // Si es un servicio único y no tiene tramos, se cobra todo en el primer mes (diferencia por moneda)
      if (isUniqueService && (!charge.tramo || charge.tramo === "null")) {
        const firstMonthKey = startDateUTC.format("YYYY-MM");
        let monthlyCharge = 0;
        if (charge.moneda === "UF") {
          monthlyCharge = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          //console.log(monthlyCharge);
        } else if (charge.moneda === "CLP") {
          monthlyCharge = charge.tarifa_mensual ? parseFloat(charge.tarifa_mensual) : 0;
          //console.log(monthlyCharge);
        } else {
          monthlyCharge = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          //console.log(monthlyCharge);
        }
        // Se agrega el cargo solo al primer mes
        if (!monthlyCharges[firstMonthKey]) {
          monthlyCharges[firstMonthKey] = 0;
        }
        monthlyCharges[firstMonthKey] += parseFloat(monthlyCharge);
      }
      // Si es un servicio único con cuotas (Cuota X), se distribuye en diferentes meses
      else if (isUniqueService && charge.tramo.includes("Cuota")) {
        // Extrae el número de cuota desde el texto "Cuota X" (Ejemplo: "Cuota 2" → 2)
        const cuotaMatch = charge.tramo.match(/Cuota (\d+)/);

        if (cuotaMatch && cuotaMatch[1]) {
          const cuotaNumber = parseInt(cuotaMatch[1], 10); // Convierte el número de cuota a entero

          // Calcula el mes en el que se debe aplicar la cuota
          const monthWithOffset = startDateUTC
            .clone()
            .add(cuotaNumber - 1, "month");

          // Verifica que el mes calculado esté dentro del período válido (antes de la fecha de finalización)
          if (monthWithOffset.isAfter(endDateUTC)) {
            return;
          }

          const monthKey = monthWithOffset.format("YYYY-MM");

          // Obtiene el monto de la cuota (diferencia por moneda)    
          let monthlyCuota = 0;
          if (charge.moneda === "UF") {
            monthlyCuota = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          } else if (charge.moneda === "CLP") {
            monthlyCuota = charge.tarifa_mensual ? parseFloat(charge.tarifa_mensual) : 0;
          } else {
            monthlyCuota = charge.tarifa_cliente ? parseFloat(charge.tarifa_cliente) : 0;
          }

          // Suma la cuota al mes correspondiente
          if (!monthlyCharges[monthKey]) {
            monthlyCharges[monthKey] = 0;
          }
          //console.log(monthlyCuota);
          monthlyCharges[monthKey] += monthlyCuota;
        } else {
          console.error("Invalid cuota format in tramo:", charge.tramo); // Muestra un error si el formato de cuota es inválido
        }
      }
      // Caso general: Se distribuyen los cargos de manera proporcional por mes
      else {
        let currentDate = startDateUTC.clone();
        while (currentDate.isSameOrBefore(endDateUTC)) {
          const currentMonthKey = currentDate.format("YYYY-MM");
          let daysInPeriod = 30; // Se asume que cada mes tiene 30 días por defecto

          // Caso donde todo el período cae dentro de un solo mes
          if (
            startDateUTC.isSame(endDateUTC, "month") &&
            startDateUTC.isSame(endDateUTC, "year")
          ) {
            // Calcula los días entre la fecha de inicio y la de fin dentro del mismo mes
            daysInPeriod = endDateUTC.date() - startDateUTC.date() + 1;
          }
          // Caso del primer mes del período
          else if (
            currentDate.isSame(startDateUTC, "month") &&
            currentDate.isSame(startDateUTC, "year")
          ) {
            // Calcula los días desde la fecha de inicio hasta el final del mes
            daysInPeriod = Math.min(
              currentDate.endOf("month").date() - startDateUTC.date() + 1,
              30
            );
          }
          // Caso del último mes del período
          else if (
            currentDate.isSame(endDateUTC, "month") &&
            currentDate.isSame(endDateUTC, "year")
          ) {
            // const endOfMonthDate = currentDate.endOf("month").date();
            // if (endDateUTC.date() === endOfMonthDate) {
            //   daysInPeriod = 30;
            // } else {
            //   daysInPeriod = endDateUTC.date();
            // }

            // FIX: base 30 siempre
            daysInPeriod = Math.min(endDateUTC.date(), 30);
          }
          // En los meses intermedios, "daysInPeriod" se mantiene en 30

          // Se calcula el cargo diario
          const dailyCharge = charge.tarifa_diaria
            ? parseFloat(charge.tarifa_diaria)
            : 0;
          const monthlyCharge =
            charge.relacion === "servicio" &&
            !charge.descripcion.includes("Gasto Comun")
              ? charge.tarifa_mensual // Si es un servicio, usa la tarifa mensual
              : dailyCharge * daysInPeriod; // Si no, calcula con la tarifa diaria

          // Se inicializa el mes si no existe
          if (!monthlyCharges[currentMonthKey]) {
            monthlyCharges[currentMonthKey] = 0;
          }
          //console.log(monthlyCharge);
          // Se suma el cargo mensual calculado al mes correspondiente
          monthlyCharges[currentMonthKey] += parseFloat(monthlyCharge);

          // Se avanza al siguiente mes
          currentDate.add(1, "month").startOf("month");
        }
      }
    });
    //console.log(monthlyCharges);
    return monthlyCharges; // Devuelve el objeto con los cargos distribuidos por mes
  }

  /**
   * Normaliza una fecha a formato "YYYY-MM"
   * @param {string} dateString - La fecha en distintos formatos posibles
   * @return {string|null} La fecha normalizada en formato "YYYY-MM" o null si el formato no es válido
   */
  const normalizeDate = (dateString) => {
    // Lista de formatos de fecha aceptados
    const formats = ["YYYY-MM","YYYY/MM","MM/YYYY","MMM YYYY","MMMM YYYY","YYYY-MM-DD","YYYY/MM/DD","DD/MM/YYYY","DD-MM-YYYY",];

    // Intenta convertir la fecha con los formatos permitidos
    const date = moment(dateString, formats, true);

    // Si la fecha es válida, la devuelve en formato "YYYY-MM", si no, devuelve null
    return date.isValid() ? date.format("YYYY-MM") : null;
  };

  // Estado para controlar si se debe mostrar el resumen mensual
  const [verResumenMensual, setVerResumenMensual] = useState(false);

  /**
   * Formatea un mes dado en formato "YYYY-MM" a su nombre en texto completo
   * @param {string} dateString - La fecha en formato "YYYY-MM"
   * @return {string} Nombre del mes en texto (ej. "January", "February")
   */
  const formatMonth = (dateString) => {
    const date = moment(dateString, "YYYY-MM");
    return date.format("MMMM"); // Devuelve el nombre del mes en inglés
  };

  // Convierte el objeto "resumenMensual" en un array de objetos con información formateada
  const allData = Object.entries(resumenMensual).map(([date, value]) => {
    const normalizedDate = normalizeDate(date); // Normaliza la fecha
    if (!normalizedDate) {
      throw new Error(`Invalid date format: ${date}`); // Lanza un error si la fecha no es válida
    }
    return {
      id: normalizedDate, // Guarda la fecha normalizada como identificador
      formattedMonth: formatMonth(normalizedDate), // Obtiene el nombre del mes formateado
      value: `${value.toLocaleString("en-US").replace(".", ",")} UF`, // Formatea el valor en UF
    };
  });

  // Llena la estructura "matrixData" con los valores organizados por año y mes
  allData.forEach(({ id, value }) => {
    const [year, month] = id.split("-"); // Extrae el año y el mes del ID de fecha
    const paddedMonth = month.padStart(2, "0"); // Asegura que el mes tenga dos dígitos

    // Si el año no existe en la matriz, se crea
    if (!matrixData[year]) {
      matrixData[year] = {};
    }

    // Se almacena el valor en la matriz bajo el año y el mes correspondiente
    matrixData[year][paddedMonth] = value;
  });

  // Extrae todos los meses únicos presentes en los datos
  const months = Object.keys(
    allData.reduce((acc, { id }) => {
      const [, month] = id.split("-"); // Obtiene el mes de la fecha normalizada
      acc[month] = true; // Marca el mes como existente en el conjunto
      return acc;
    }, {})
  );

  const sortedMonths = months.sort((a, b) => a - b);

  moment.locale("es");

  const columns = [
    { field: "year", header: "Año" },
    ...sortedMonths.map((month) => {
      const monthName = moment(month, "M")
        .locale("es") // Ensure locale is set for each formatting
        .format("MMMM")
        .replace(/^\w/, (c) => c.toUpperCase());

      return {
        field: month,
        header: monthName,
      };
    }),
  ];

  // -------------------------------------------------------
  // cuadro resumen mensual
  // -------------------------------------------------------
  const handleShowResumenMensual = () => {
    // Se combinan los arrays de cargos que se deben procesar
    const chargesArrays = [flattenedDataArriendo, servicios]; // Incluye productos y servicios
    const uniqueServiceCharges = serviciosUnicos; // Incluye servicios únicos
    const combinedMonthlyCharges = {}; // Objeto para almacenar los cargos combinados por mes

    // Se calcula el total mensual de los cargos regulares (productos y servicios)
    chargesArrays.forEach((charges) => {
      const monthlyCharges = calculateMonthlyCharges(charges, false); // Se calculan los cargos mensuales

      // Se combinan los cargos mensuales en un solo objeto sumando los valores de cada mes
      Object.keys(monthlyCharges).forEach((key) => {
        if (!combinedMonthlyCharges[key]) {
          combinedMonthlyCharges[key] = 0; // Se inicializa si no existe
        }
        combinedMonthlyCharges[key] += monthlyCharges[key]; // Se suman los valores de cada mes
      });
    });

    // Se calculan los cargos mensuales de los servicios únicos
    const monthlyUniqueCharges = calculateMonthlyCharges(
      uniqueServiceCharges,
      true
    );

    // Se suman los cargos de los servicios únicos al total combinado
    Object.keys(monthlyUniqueCharges).forEach((key) => {
      if (!combinedMonthlyCharges[key]) {
        combinedMonthlyCharges[key] = 0; // Se inicializa si no existe
      }
      combinedMonthlyCharges[key] += monthlyUniqueCharges[key]; // Se suman los valores de cada mes
    });

    /*const monthlyChargesArriendo = calculateMonthlyCharges(flattenedDataArriendo, false);
    console.log("Cargos mensuales ARRIENDO (productos y subproductos):");
    console.table(monthlyChargesArriendo);
    const monthlyChargesServiciosRegulares = calculateMonthlyCharges(servicios, false);
    console.log("Cargos mensuales SERVICIOS regulares:");
    console.table(monthlyChargesServiciosRegulares);
    console.table(combinedMonthlyCharges);*/

    // Se almacena el resumen mensual en el estado
    setResumenMensual(combinedMonthlyCharges);

    // Se activa la visualización del resumen mensual
    setVerResumenMensual(true);
  };

  const years = Object.keys(matrixData);

  // Transform matrixData into matrixArray
  const matrixArray = years.map((year) => {
    const yearData = { year: year }; // Include the year field
    sortedMonths.forEach((month) => {
      const monthField = String(month).padStart(2, "0"); // Ensure month is two digits
      yearData[monthField] = matrixData[year][month] || ""; // Provide default value if missing
    });
    return yearData;
  });

  /**
   * Desactiva un ítem de la cotización llamando a la API.
   * @param {Object} item - Objeto que contiene la información del ítem a desactivar.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const deactivateItem = async (item) => {
    let idsArray = [];
    if (typeof item?.id === "number" ) {
        idsArray = [item.id];
    } else {
        idsArray = [];
    }

    // Debug opcional:
    console.log('deactivateItem idsArray:', idsArray);

    const results = [];
    for (const detailId of idsArray) {
      const idCotizacion = item.id_cotizacion;
      const queryParams = new URLSearchParams({
        id: detailId,
        idCotizacion,
      });
      const url = `${baseUrl}deactivateDetalleCotizacion?${queryParams}`;

      try {
        const response = await fetch(url, { method: "PUT" });
        if (!response.ok) {
          throw new Error(`Network response was not ok. Status: ${response.status}`);
        }
        const json = await response.json();
        results.push({ id: detailId, ok: true, data: json });
      } catch (error) {
        console.error(`Error fetching data from ${url}:`, error);
        results.push({ id: detailId, ok: false, error });
      }
    }

    return results;
  };

  const handleInfinity = (value) => {
    return isFinite(value) ? value : 0;
  };

  // API para insertar un subproducto
  const buildInsertSubproductoUrl = (
    idEmpresa,
    idProducto,
    idTipoSubproducto,
    metraje
  ) => {
    return `${baseUrl}insertProductoSubproducto?idEmpresa=${idEmpresa}&idProducto=${idProducto}&idTipoSubproducto=${idTipoSubproducto}&metraje=${metraje}&incluido=${true}`;
  };
  /**
   * Envía datos de una cotización a la API para su inserción o actualización.
   * @param {Object} item - Objeto con la información del ítem de la cotización.
   * @param {boolean} isCerrar - Indica si se está cerrando la cotización.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const postDataCotizacion = async (item, isCerrar) => {
    const {
      id,
      id_cotizacion,
      id_empresa,
      relacion,
      tramo,
      descripcion,
      desde,
      hasta,
      cobro,
      tipo,
      contrato,
      consolidado,
      agrupamiento,
      unidad,
      cantidad,
      moneda,
      tarifa_base,
      tarifa_cliente,
      tarifa_diaria,
      tarifa_mensual,
      descuento,
      id_elemento,
      codigo_producto,
      id_elemento_producto,
    } = item;
    let url; // Variable para almacenar la URL a utilizar en la solicitud
    console.log(item);
    /**
     * Reemplaza valores infinitos por 0
     * @param {number} value - Valor a evaluar
     * @return {number} Retorna 0 si el valor es infinito, de lo contrario, devuelve el mismo valor
     */
    const handleInfinity = (value) =>
      value === Infinity || value === -Infinity ? 0 : value;

    /**
     * Construye una URL con parámetros de consulta
     * @param {string} baseUrl - URL base de la API
     * @param {Object} params - Objeto con los parámetros a incluir en la URL
     * @return {string} URL con los parámetros codificados
     */
    const buildURL = (baseUrl, params) => {
      return `${baseUrl}?${Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&")}`;
    };

    // Si el ítem es un subproducto y se está cerrando la cotización, se realiza una validación adicional
    if (relacion === "subproducto" && isCerrar === true) {
      // Se extrae la segunda parte de la descripción del subproducto
      const [_, secondPart] = descripcion.split("-");

      // Se busca en "flattenedDataArriendo" un ítem cuya descripción coincida con la segunda parte extraída
      const matchingItem = flattenedDataArriendo.find(
        (item) => item.descripcion === secondPart.trim()
      );

      // Si se encuentra un ítem coincidente, se genera la URL de inserción del subproducto y se envía la solicitud
      if (matchingItem) {
        const insertSubproductoUrl = buildInsertSubproductoUrl(
          id_empresa,
          matchingItem.id_elemento,
          id_elemento,
          cantidad
        );
        try {
          const subproductoResponse = await fetch(insertSubproductoUrl, {
            method: "POST",
            redirect: "follow",
          });
          // Si la respuesta no es exitosa, se lanza un error
          if (!subproductoResponse.ok) {
            throw new Error(
              `Error fetching data from ${insertSubproductoUrl}. Status: ${subproductoResponse.status}`
            );
          }
        } catch (error) {
          console.error(`Error fetching subproducto URL:`, error);
          throw error;
        }
      }
    }

    let codigosArray = [];
    
    // Se construye el objeto con los parámetros de la solicitud
    const params = {
      idCotizacion: id_cotizacion,
      relacion: relacion,
      idElemento: id_elemento,
      idElementoProducto: id_elemento_producto || null,
      idEmpresa: id_empresa,
      tramo: tramo || null,
      descripcion: descripcion,
      desde,
      hasta,
      documentoCobro: cobro,
      tipo: tipo,
      contrato,
      consolidado: consolidado,
      agrupamiento: agrupamiento,
      unidadMedida: unidad || "",
      cantidad: cantidad || 0,
      moneda,
      tarifaBase: tarifa_base || 0,
      tarifaCliente: tarifa_cliente || 0,
      tarifaDiaria: tarifa_diaria || 0,
      tarifaMensual: tarifa_mensual || 0,
      descuento: handleInfinity(descuento),
      activo: 1,
      id: id || null,
    };

    if (id == null) {
      params.codigoProducto = codigosArray;
      url = buildURL(`${baseUrl}insertDetalleCotizacion`, params); // Inserta un nuevo detalle de cotización
    } else {
      params.id = id;
      params.codigoProducto = codigosArray;
      url = buildURL(`${baseUrl}updateDetalleCotizacion`, params); // Actualiza un detalle de cotización existente
    }

    try {
      // Realiza la solicitud a la API con el método GET
      const response = await fetch(url);

      // Verifica si la respuesta de la API es válida, de lo contrario, lanza un error
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }

      // Retorna la respuesta de la API en formato JSON
      return await response.json();
    } catch (error) {
      // Captura y muestra en consola cualquier error ocurrido durante la solicitud
      console.error(`Error fetching data from ${url}:`, error);
      throw error;
    }
  };

  /**
   * Actualiza los datos de una cotización enviándolos a la API.
   * @param {Object} item - Objeto que contiene la información del ítem de la cotización.
   * @param {boolean} isCerrar - Indica si se está cerrando la cotización.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const postUpdateDataCotizacion = async (item, isCerrar) => {
    const {
      id,
      id_cotizacion,
      id_empresa,
      relacion,
      tramo,
      descripcion,
      desde,
      hasta,
      cobro,
      tipo,
      contrato,
      consolidado,
      agrupamiento,
      unidad,
      cantidad,
      moneda,
      tarifa_base,
      tarifa_cliente,
      tarifa_diaria,
      tarifa_mensual,
      descuento,
      id_elemento,
      codigo_producto,
      id_elemento_producto,
    } = item;

    let url; // Variable para almacenar la URL de la solicitud

    /**
     * Reemplaza valores infinitos por 0
     * @param {number} value - Valor a evaluar
     * @return {number} Retorna 0 si el valor es infinito, de lo contrario, devuelve el mismo valor
     */
    const handleInfinity = (value) =>
      value === Infinity || value === -Infinity ? 0 : value;

    /**
     * Construye una URL con parámetros de consulta
     * @param {string} baseUrl - URL base de la API
     * @param {Object} params - Objeto con los parámetros a incluir en la URL
     * @return {string} URL con los parámetros codificados
     */
    const buildURL = (baseUrl, params) => {
      return `${baseUrl}?${Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&")}`;
    };

    // Se construye el objeto con los parámetros de la solicitud
    const params = {
      idCotizacion: id_cotizacion,
      relacion: relacion,
      idElemento: id_elemento,
      idElementoProducto: id_elemento_producto || null,
      idEmpresa: id_empresa,
      tramo: tramo || null,
      descripcion: descripcion,
      desde,
      hasta,
      documentoCobro: cobro,
      tipo: tipo,
      contrato,
      consolidado: consolidado,
      agrupamiento: agrupamiento,
      unidadMedida: unidad || "",
      cantidad: cantidad || 0,
      moneda,
      tarifaBase: tarifa_base || 0,
      tarifaCliente: tarifa_cliente || 0,
      tarifaDiaria: tarifa_diaria || 0,
      tarifaMensual: tarifa_mensual || 0,
      descuento: handleInfinity(descuento) || 0,
      activo: 1,
      codigoProducto: codigo_producto,
      id: id || null,
    };

    console.log(params.ids);
    url = buildURL(`${baseUrl}actualizarDetalleCotizacion`, params);

    try {
      // Realiza la solicitud a la API con el método GET
      const response = await fetch(url);

      // Verifica si la respuesta de la API es válida, de lo contrario, lanza un error
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }

      // Retorna la respuesta de la API en formato JSON
      return await response.json();
    } catch (error) {
      // Captura y muestra en consola cualquier error ocurrido durante la solicitud
      console.error(`Error fetching data from ${url}:`, error);
      throw error;
    }
  };

  /**
   * Actualiza una cotización enviando los datos a la API.
   * @param {number} idCotizacion - ID de la cotización a actualizar.
   * @param {number} idCliente - ID del cliente asociado a la cotización.
   * @param {number} idEstado - ID del estado actual de la cotización.
   * @param {number} idCreador - ID del usuario que creó la cotización.
   * @param {string} desde - Fecha de inicio de la cotización en formato "YYYY-MM-DD".
   * @param {string} hasta - Fecha de finalización de la cotización en formato "YYYY-MM-DD".
   * @param {number} aviso - Número de días de aviso previo para la cotización.
   * @return {Promise<Object>} Respuesta de la API en formato JSON si la solicitud es exitosa.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const updateCotizacion = async (
    idCotizacion,
    idCliente,
    idEstado,
    idCreador,
    desde,
    hasta,
    aviso,
    observacion,
    vencimiento
  ) => {
    try {
      // Construye los parámetros de la consulta para la URL
      const queryParams = new URLSearchParams({
        idCotizacion,
        idCliente,
        idEstado,
        idCreador,
        desde,
        hasta,
        aviso,
      });

      if (observacion) {
        queryParams.append("observacion", observacion);
      }
      if (vencimiento) {
        queryParams.append("vencimiento", vencimiento);
      }

      // Construye la URL con los parámetros de la cotización
      const url = `${baseUrl}updateCotizacion?${queryParams}`;

      // Realiza la solicitud a la API con el método GET
      const response = await fetch(url);

      // Verifica si la respuesta de la API es válida, de lo contrario, lanza un error
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }

      // Convierte la respuesta en formato JSON y la devuelve
      const data = await response.json();
      return data;
    } catch (error) {
      // Captura y muestra en consola cualquier error ocurrido durante la solicitud
      console.error(`Error updating cotizacion:`, error);
      throw error;
    }
  };

  const updatePlazoFirma = async (idContrato, diasFirma) => {
    try {
      // Construye los parámetros de la consulta para la URL
      const queryParams = new URLSearchParams({
        idContrato,
        diasFirma,
      });
      // Construye la URL con los parámetros de la cotización
      const url = `${baseUrl}updateContratoPlazoFirma?${queryParams}`;

      // Realiza la solicitud a la API con el método GET
      const response = await fetch(url);

      // Verifica si la respuesta de la API es válida, de lo contrario, lanza un error
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }

      // Convierte la respuesta en formato JSON y la devuelve
      const data = await response.json();
      return data;
    } catch (error) {
      // Captura y muestra en consola cualquier error ocurrido durante la solicitud
      console.error(`Error updating plazo firma:`, error);
      throw error;
    }
  };

  /**
   * Formatea una fecha en formato "DD/MM/YYYY" a "YYYY-MM-DD".
   * @param {string} dateString - Fecha en formato "DD/MM/YYYY".
   * @return {string} Fecha formateada en "YYYY-MM-DD" o la misma fecha si no coincide con el formato esperado.
   */
  function formatDate(dateString) {
    // Se divide la fecha en partes usando "/"
    const parts = dateString.split("/");

    // Si la fecha tiene tres partes, se asume que es "DD/MM/YYYY"
    if (parts.length === 3) {
      const [day, month, year] = parts;

      // Se asegura de que el día y el mes tengan dos dígitos
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");

      // Retorna la fecha en el formato "YYYY-MM-DD"
      return `${year}-${formattedMonth}-${formattedDay}`;
    }

    // Si no tiene el formato esperado, devuelve la fecha sin modificar
    return dateString;
  }

  /**
   * Guarda la cotización actualizando los datos en la API.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const guardarCotizacion = async (items) => {
    // Se combinan todos los elementos de la cotización en un solo array
    const allItems = Array.isArray(items) ? items : detallesCobro; // EL FINAL viene de la pagina cotizacionActions
    try {
      setLoading(true); // Se activa el estado de carga

      // Se formatean las fechas de los elementos si es necesario
      const formattedAllItems = allItems.map((item) =>
        formatDatesIfNeeded(item, false)
      );

      // 1) Desactivar ítems marcados para eliminar
      const deactivatePromises = itemsPorEliminar.map((item) =>
        deactivateItem(item)
      );
      await Promise.all(deactivatePromises);

      // 2) Separar ítems a actualizar vs insertar
      const itemsToUpdate = formattedAllItems.filter((i) => i.id != null);
      const itemsToInsert = formattedAllItems.filter((i) => i.id == null);

      // 3) Actualizar los existentes usando el servicio de actualización
      const updatePromises = itemsToUpdate.map((item) =>
        postUpdateDataCotizacion(item, false)
      );

      // 4) Insertar los nuevos usando el servicio de inserción
      const insertPromises = itemsToInsert.map((item) =>
        postDataCotizacion(item, false)
      );

      // Ejecutar en paralelo
      await Promise.all([...updatePromises, ...insertPromises]);

      // 5) Actualizar rango de fechas de la cotización con base en los ítems
      const fechasDesde = formattedAllItems.map((item) =>
        moment(item.desde, "YYYY-MM-DD")
      );
      const fechasHasta = formattedAllItems.map((item) =>
        moment(item.hasta, "YYYY-MM-DD")
      );

      const fechaMin = moment.min(fechasDesde);
      const fechaMax = moment.max(fechasHasta);

      const desdeTransformed = formatDate(fechaMin.format("YYYY-MM-DD"));
      const hastaTransformed = formatDate(fechaMax.format("YYYY-MM-DD"));

      let vencimiento = null;
      try {
        const url = `${baseUrl}getCotizacionById?idCotizacion=${idCotizacion}`;
        const cotResp = await fetchData(url);
        if (cotResp?.mensaje === "OK" && cotResp.cotizacion?.vencimiento) {
            const cv = cotResp.cotizacion.vencimiento;

            if (typeof cv === "string") {
                // Soporta "DD/MM/YYYY" y "YYYY-MM-DD" de forma estricta
                const m = cv.includes("/")
                    ? moment(cv, "DD/MM/YYYY", true)
                    : moment(cv, "YYYY-MM-DD", true);
                vencimiento = m.isValid() ? m.format("YYYY-MM-DD") : null;
            } else if (cv instanceof Date) {
                vencimiento = moment(cv).format("YYYY-MM-DD");
            } else if (typeof cv?.format === "function") {
                vencimiento = cv.format("YYYY-MM-DD");
            } else {
                vencimiento = null;
            }
        } else {
            vencimiento = null;
        }
    } catch (e) {
        vencimiento = null;
    }
  
      // console.log("VENCIMIENTO", vencimiento);
      // console.log("OBSERVACION", observacion);
      // 6) Se actualiza la cabecera de la cotización en la API
      await updateCotizacion(
        idCotizacion,
        idCliente,
        cotizacion?.estado?.id_estado, // Estado de la cotización actualizado
        sessionStorage.getItem("usuario_id"), // ID del usuario que guarda la cotización
        desdeTransformed,
        hastaTransformed,
        0,// Aviso en 0 (posiblemente sin aviso)
        observacion,
        vencimiento
      );

      // Refrescar detalle
      await getDetalleData();
      setLoading(false);
    } catch (error) {
      console.error("Error posting data:", error);
      setLoading(false); // Se desactiva el estado de carga en caso de error
    }
  };

  /**
   * Construye la URL para crear un contrato a partir de una cotización.
   * @param {number} idCotizacion - ID de la cotización.
   * @return {string} URL de la API para crear el contrato.
   */
  const buildCrearContratoUrl = (idCotizacion) => {
    return `${baseUrl}crearContratoFromCotizacion?idCotizacion=${idCotizacion}`;
  };

  /** Construye la URL para crear un contrato a partir de una cotización.
   * @param {number} idCotizacion - ID de la cotización.
   * @param {number} idContrato - ID de la cotización.
   * @return {string} URL de la API para crear el contrato.
   */
  const buildActualizarContratoUrl = (idCotizacion, idContrato) => {
    return `${baseUrl}actualizarContratoFromCotizacion?idCotizacion=${idCotizacion}&idContrato=${idContrato}`;
  };

  /**
   * Construye la URL para consultar si existe un contrato por cotización.
   * @param {number} idCotizacion - ID de la cotización.
   * @return {string} URL de la API para consultar el contrato.
   */
  const buildConsultarContratoUrl = (idCotizacion) => {
    return `${baseUrl}getContratoByCotizacionId?idCotizacion=${idCotizacion}`;
  };



  /**
   * Calcula los cargos mensuales por tipo de servicio o producto.
   * @param {Array} charges - Lista de cargos a procesar.
   * @param {boolean} isUniqueService - Indica si el cálculo es para un servicio único.
   * @return {Object} Un objeto con los cargos mensuales y los detalles de cada cargo.
   */
  function calculateMonthlyChargesByType(charges, isUniqueService = false, ctx={}) {
    const monthlyCharges = {}; // Objeto para almacenar los totales por mes
    const monthlyDetailedCharges = {}; // Objeto para almacenar los detalles de cada cargo por mes

    /**
     * Convierte una cadena de fecha en un objeto moment.js
     * @param {string} dateString - Fecha en formato "YYYY-MM-DD".
     * @return {Object} Objeto moment con la fecha parseada.
     */
    const convertToDateObject = (dateString) => {
      return moment(dateString, "YYYY-MM-DD", true);
    };

    /**
     * Agrega un cargo al resumen mensual de cargos.
     * @param {string} monthKey - Clave del mes en formato "YYYY-MM".
     * @param {Object} charge - Objeto con la información del cargo.
     * @param {number} amount - Monto del cargo a agregar.
     */
    const addChargeToMonthlyCharges = (monthKey, charge, amount) => {
      if (!monthlyCharges[monthKey]) {
        monthlyCharges[monthKey] = {
          total_factura_afecta: 0,
          total_factura_exenta: 0,
          total_nota_cobro: 0,
        };
        monthlyDetailedCharges[monthKey] = [];
      }

      // Convierte el monto a UF
      const monedaUf = monedaOptions.find((m) => m.codigo === "UF");
      let convertedAmount = 0;
      if (charge.moneda === "UF") {
        convertedAmount = parseFloat(amount.toFixed(2));
      } else if (charge.moneda === "CLP") { // Convierte CLP a UF dividiendo por la tasa de UF
        convertedAmount = parseFloat((amount / monedaUf.tipoCambio).toFixed(2));
      } else if (charge.moneda === "USD") { // Convierte USD a CLP y luego a UF: (monto * tasaUSD) / tasaUF
        const monedaUsd = monedaOptions.find((m) => m.codigo === "USD"); 
        convertedAmount = parseFloat((amount * monedaUsd.tipoCambio / monedaUf.tipoCambio).toFixed(2));
      }

      // Se asigna el monto convertido a UF a la categoría correspondiente
      if (charge.cobro === "Factura Afecta") {
        monthlyCharges[monthKey].total_factura_afecta += convertedAmount;
      } else if (charge.cobro === "Factura Exenta") {
        monthlyCharges[monthKey].total_factura_exenta += convertedAmount;
      } else if (charge.cobro === "Nota de Cobro") {
        monthlyCharges[monthKey].total_nota_cobro += convertedAmount;
      }

      // Se asigna el monto total a la categoría correspondiente
      let moneda = monedaOptions.find((m) => m.codigo === charge.moneda);
      let amountTotal = 0;
      let amountClp = 0;
      
      if(moneda){
        // Si la moneda es UF, se convierte a UF y a CLP
        if (charge.moneda === "UF") {
          let amountInUF = parseFloat(amount.toFixed(2));
          let amountInCLP = parseFloat((amount * monedaUf.tipoCambio).toFixed(2));
          amountTotal += amountInUF;
          amountClp += amountInCLP;

        } else if (charge.moneda === "CLP") {
          // Si la moneda es CLP, se mantiene el monto total en clp y se acumula el monto
          amountTotal += amount;
          amountClp += amount;

        } else if (charge.moneda === "USD") {
          // Si la moneda es USD, se convierte a UF y a CLP
          let monedaUsd = monedaOptions.find((m) => m.codigo === "USD");
          let amountInUSD = parseFloat(amount.toFixed(2));
          let amountInCLP = parseFloat((amount * monedaUsd.tipoCambio).toFixed(2));
          amountTotal += amountInUSD;
          amountClp += amountInCLP;
        }
      }

      // Se verifica si ya existe un detalle de cargo para este mes
      const existingDetail = monthlyDetailedCharges[monthKey].find(
        (d) =>
          d.item === charge.descripcion &&
          d.servicios === getServicios(charge) &&
          d.codigoProducto === charge.codigo_producto &&
          d.docCobro === charge.cobro &&
          d.moneda === charge.moneda &&
          d.unidadMedida === charge.unidad &&
          d.id === charge.id &&
          d.agrupamiento === charge.agrupamiento &&
          d.idElemento === charge.id_elemento
      );
      // Si el detalle ya existe, se acumula el monto, de lo contrario, se crea un nuevo registro
      if (existingDetail) {
        existingDetail.total += amountTotal;
        existingDetail.totalClp += amountClp;
      } else {
        const newDetail = {
          item: charge.descripcion,
          servicios: getServicios(charge),
          lectInicial: 0,
          lectFinal: 0,
          consumo: 0,
          unidadMedida: charge.unidad,
          moneda: charge.moneda,
          docCobro: charge.cobro,
          total:  amountTotal, 
          total_clp: amountClp,
          observador: "",
          cuota: charge.tramo && charge.tramo !== "null" ? parseInt(charge.tramo) : null,
          codigoProducto: charge.codigo_producto,
          consolidado: charge.consolidado,
          agrupamiento: charge.agrupamiento,
          id: charge.id,
          //idCombo: charge.id_combo,
          idElemento: charge.id_elemento,
        }
        monthlyDetailedCharges[monthKey].push(newDetail);
      }
    };
    
    const processCharges = charges;
    /**
     * Determina la categoría del cargo basado en su relación.
     * @param {Object} charge - Objeto con la información del cargo.
     * @return {string} Categoría del cargo (arriendo, obra civil, gasto común, servicio).
     */
    const getServicios = (charge) => {
      if (charge.relacion === "producto" || charge.relacion === "subproducto") {
        return "arriendo";
      }
      if (charge.relacion === "servicio") {
        if (charge.descripcion.includes("Obra Civil")) {
          return "obra civil";
        }
        if (charge.descripcion.includes("Gasto Comun")) {
          return "gasto comun";
        }
        return "servicio";
      }
      return "";
    };

    // const processCharges = expandMaskItems(charges);

    processCharges.forEach((charge) => {
      const startDateUTC = moment(charge.desde, "YYYY-MM-DD", true)
        .startOf("day")
        .utc();
      const endDateUTC = moment(charge.hasta, "YYYY-MM-DD", true)
        .startOf("day")
        .utc();

      if (isUniqueService && (!charge.tramo || charge.tramo === "null") && !((charge.id_combo || charge.idCombo) && charge.relacion === "servicio" && (charge.descripcion || "").includes("Gasto Comun"))) {
        // Si es un servicio único sin tramo, se cobra todo en el primer mes
        const firstMonthKey = startDateUTC.format("YYYY-MM");
        const monthlyCharge = charge.tarifa_cliente
          ? parseFloat(charge.tarifa_cliente)
          : 0;
        addChargeToMonthlyCharges(firstMonthKey, charge, monthlyCharge);
      } else if (isUniqueService && charge.tramo.includes("Cuota")) { 
        const cuotaMatch = charge.tramo.match(/Cuota (\d+)/);
        const cuotaNumber = parseInt(cuotaMatch[1], 10);

        // Calcula el mes donde se debe aplicar la cuota
        const monthWithOffset = startDateUTC
          .clone()
          .add(cuotaNumber - 1, "month");

        // Verifica que el mes calculado esté dentro del período válido
        if (monthWithOffset.isAfter(endDateUTC)) {
          return;
        }

        const monthKey = monthWithOffset.format("YYYY-MM");
        const monthlyCuota = charge.tarifa_cliente
          ? parseFloat(charge.tarifa_cliente)
          : 0;
        addChargeToMonthlyCharges(monthKey, charge, monthlyCuota);
      } else {
        // Caso general: se distribuyen los cargos en los meses correspondientes
        let currentDate = startDateUTC.clone();

        while (currentDate.isSameOrBefore(endDateUTC)) {
          const currentMonthKey = currentDate.format("YYYY-MM");
          let daysInPeriod = 30;

          if (startDateUTC.isSame(endDateUTC, "month") && startDateUTC.isSame(endDateUTC, "year")){
            // Si el período está dentro de un solo mes, se calcula la cantidad de días exactos
            daysInPeriod = endDateUTC.date() - startDateUTC.date() + 1;
          } else if (currentDate.isSame(startDateUTC, "month") && currentDate.isSame(startDateUTC, "year")) {
            // Si es el primer mes del período, se calcula desde el día de inicio hasta fin de mes
            daysInPeriod = Math.min(
              currentDate.endOf("month").date() - startDateUTC.date() + 1,
              30
            );
          } else if (currentDate.isSame(endDateUTC, "month") && currentDate.isSame(endDateUTC, "year")) {
            // Si es el último mes del período, se calcula hasta la fecha de fin
            // daysInPeriod = endDateUTC.date();

            // FIX: mantener base 30 días
            daysInPeriod = Math.min(endDateUTC.date(), 30);
          }

          const dailyCharge = charge.tarifa_diaria
            ? parseFloat(charge.tarifa_diaria)
            : 0;

          const monthlyCharge =
            charge.relacion === "servicio" &&
            !charge.descripcion.includes("Gasto Comun")
              ? charge.moneda === "UF"
                ? charge.tarifa_mensual
                  ? parseFloat(charge.tarifa_mensual)
                  : 0
                : charge.tarifa_cliente
                  ? parseFloat(charge.tarifa_cliente)
                  : 0
              : dailyCharge * daysInPeriod;

          addChargeToMonthlyCharges(
            currentMonthKey,
            charge,
            parseFloat(monthlyCharge)
          );

          currentDate.add(1, "month").startOf("month");
          }
        }
      }
    );
    return { monthlyCharges, monthlyDetailedCharges };
  }

  // api para insertar el detalle de cobro en la tabla periodo_facturacion
  const savePeriodoFacturacionArray = async (periodoFacturacionArray) => {
    const url = `${baseUrl}insertPeriodoFacturacionArray`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(periodoFacturacionArray),
    });

    if (!response.ok) {
      throw new Error("Hubo un error al guardar los periodos de facturación");
    }
  };

  // Funcion para cerrar un contrato
  const cerrarContrato = async (finalitems, options = {}) => {
    try {
      // Se activa el estado de carga para cotizacionActions
      setLoading(true);
      setLoadingAsig(true);
      const { aborted } = await ejecutarCierreContrato({
        finalitems,
        baseUrl,
        urlContratos,
        idCotizacion,
        idCliente,
        cotizacion,
        diasAviso,
        diasFirma,
        flattenedDataArriendo,
        servicios,
        serviciosUnicos,
        formatDatesIfNeeded,
        guardarCotizacion,
        buildInsertSubproductoUrl,
        buildConsultarContratoUrl,
        buildActualizarContratoUrl,
        buildCrearContratoUrl,
        calculateMonthlyChargesByType,
        savePeriodoFacturacionArray,
        formatDate,
        updateCotizacion,
        updatePlazoFirma,
        navigate,
        cobroArriendoEnPeriodoActual:
          options.cobroArriendoEnPeriodoActual ?? true,
      });
      if (aborted) setLoading(false);

    } catch (error) {
      console.error("Error posting data:", error);
    }finally {
      setLoadingAsig(false);
    }
  };

  const cobroOptionsFlattened = [{ label: "Factura Afecta", value: "Factura Afecta" },{ label: "Factura Exenta", value: "Factura Exenta" },{ label: "Nota de Cobro", value: "Nota de Cobro" },];

  const cobroOptionsServicios = [{ label: "Factura Afecta", value: "Factura Afecta" },{ label: "Factura Exenta", value: "Factura Exenta" },{ label: "Nota de Cobro", value: "Nota de Cobro" },];

  const cobroOptionsServiciosUnicos = [{ label: "Factura Afecta", value: "Factura Afecta" },{ label: "Factura Exenta", value: "Factura Exenta" },{ label: "Nota de Cobro", value: "Nota de Cobro" },];

  const handleTablaChange = async (rowData, newValue, tabla, campo) => {

    const updateData = (prevData) => {
      return prevData.map((item) => {
        if (
          item.descripcion === rowData.descripcion &&
          item.tramo === rowData.tramo &&
          item.id === rowData.id
        ) {
          let updatedItem = { ...item };

          if (campo === "descuento") {
            const newTarifa = item.tarifa_base * (1 - newValue / 100);
            updatedItem = {
              ...updatedItem,
              descuento: newValue,
              tarifa_cliente: newTarifa,
            };
          } else if (campo === "tarifa_cliente") {
            const percentageDifference =
              ((newValue - item.tarifa_base) / item.tarifa_base) * 100;
            updatedItem = {
              ...updatedItem,
              tarifa_cliente: newValue,
              descuento: -1 * percentageDifference,
            };
          } else if (
            campo === "cantidad" &&
            tabla === "servicios" &&
            rowData.descripcion.includes("Internet")
          ) {
            let cantidad = newValue;
            const numberOfTenths = Math.floor(cantidad / 10);

            const ufExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "UF")
                ?.tipoCambio || 1;

            // Find USD exchange rate
            const usdExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "USD")
                ?.tipoCambio || 1;

            // Amount in UF
            const amountInUF = numberOfTenths * item.tarifa_base;

            // Convert UF to CLP
            const amountInCLP = amountInUF * ufExchangeRate;

            // Convert CLP to USD
            const amountInUSD = amountInCLP / usdExchangeRate;

            if (newValue > 200) {
              cantidad = 200;
            }

            const additionalTarifaBase =
              rowData.moneda === "UF"
                ? amountInUF
                : rowData.moneda === "USD"
                ? amountInUSD
                : amountInCLP;

            updatedItem = {
              ...updatedItem,
              cantidad: cantidad,
              tarifa_cliente: additionalTarifaBase,
            };
          } else if (campo === "desde" || campo === "hasta") {
            //console.log("updatedItem", updatedItem);
            //console.log("newValue", newValue);
            const date = moment(newValue, "YYYY-MM-DD", true);
            //console.log("date", date);
            if (date.isValid()) {
              updatedItem = {
                ...updatedItem,
                [campo]: date.format("YYYY-MM-DD"),
              };
            }
          } else if (
            campo === "moneda" &&
            tabla === "servicios" &&
            rowData.descripcion.includes("Internet")
          ) {
            let cantidad = rowData.cantidad;
            const numberOfTenths = Math.floor(cantidad / 10);

            const ufExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "UF")
                ?.tipoCambio || 1;

            // Find USD exchange rate
            const usdExchangeRate =
              monedaOptions.find((moneda) => moneda.codigo === "USD")
                ?.tipoCambio || 1;

            // Amount in UF
            const amountInUF = numberOfTenths * item.tarifa_base;

            // Convert UF to CLP
            const amountInCLP = amountInUF * ufExchangeRate;

            // Convert CLP to USD
            const amountInUSD = amountInCLP / usdExchangeRate;

            const additionalTarifaBase =
              newValue === "UF"
                ? amountInUF
                : newValue === "USD"
                ? amountInUSD
                : amountInCLP;

            updatedItem = {
              ...updatedItem,
              cantidad: cantidad,
              tarifa_cliente: additionalTarifaBase,
              moneda: newValue,
            };

          } else if (campo === "agrupamiento") {
            updatedItem = {
              ...updatedItem,
              agrupamiento: newValue
            };
          } else {
            updatedItem = {
              ...updatedItem,
              [campo]: newValue,
            };
          }

          return updatedItem;
        }
        return item;
      });
    };

    if (tabla === "servicios") {
      const updatedServicios = servicios.map((item) => {
        if (item.id === rowData.id) {
          let updatedItem = { ...item, [campo]: newValue };
          if (campo === "descuento") {
            const tarifaBase = parseFloat(item.tarifa_base) || 0;
            const descuento = parseFloat(newValue) || 0;
            updatedItem.tarifa_cliente = (tarifaBase * (1 - descuento / 100)).toFixed(5);
          }
          if (campo === "tarifa_cliente") {
            const tarifaBase = parseFloat(item.tarifa_base) || 0;
            const tarifaCliente = parseFloat(newValue) || 0;
            if (tarifaBase > 0) {
              updatedItem.descuento = (((tarifaBase - tarifaCliente) / tarifaBase) * 100).toFixed(5);
            }
          }
          return updatedItem;
        }
        return item;
      });
      setServicios(updatedServicios);
    }

    if (tabla === "flattened") {
      setFlattenedDataArriendo((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    } else if (tabla === "servicios") {
      setServicios((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    } else if (tabla === "unicos") {
      setServiciosUnicos((prevData) =>
        sortDataByProductAndSubProduct(updateData(prevData))
      );
    }

    // ——————————————————————————————
    // ACTUALIZA detallesCobro (misma lógica de cálculo)
    // ——————————————————————————————
    //  setDetallesCobro ( prev =>
    //    prev . map ( item =>
    //    item . id === rowData . id
    //    ? { ... item , [ campo ]: newValue }
    //    : item
    //    )
    //  );
    setDetallesCobro((prevData) => updateData(prevData));
  };

  const handleTramoConfirmationServicio = async (descripcion) => {
    if (loading) return;
    setLoading(true);
    const duplicateTramos = tramos.filter(
      (tramo, index) =>
        tramo.descripcion === descripcion &&
        tramos.findIndex(
          (t, i) =>
            i !== index &&
            t.descripcion === descripcion &&
            moment(t.desde).isSame(moment(tramo.desde)) &&
            moment(t.hasta).isSame(moment(tramo.hasta))
        ) !== -1
    );

    if (duplicateTramos.length > 0) {
      alert("Error: Los tramos no pueden tener la misma fecha de inicio y término");
      setLoading(false);
      return;
    }
    const serviciosInside = [...servicios];
    const indexToRemove = servicios.findIndex((item) => item.descripcion === descripcion);

    if (indexToRemove !== -1) {
      const itemToRemove = serviciosInside[indexToRemove];
      await deactivateItem(itemToRemove);
      serviciosInside.splice(indexToRemove, 1);

      serviciosInside.push(...tramos);
      const matchingItems = serviciosInside.filter(
        (item) => item.descripcion === descripcion
      );

      matchingItems.forEach((item, index) => {
        item.tramo = `Tramo ${index + 1}`;
        item.id = null;
      });

      serviciosInside.sort((a, b) => {
        const nombreComparison = a.descripcion.localeCompare(b.descripcion);
        if (nombreComparison !== 0) {
          return nombreComparison;
        }

        return (
          moment(a.desde, dateFormats, true).toDate() -
          moment(b.desde, dateFormats, true).toDate()
        );
      });

      const formattedAllItems = serviciosInside.map((item) =>
        formatDatesIfNeeded(item, false)
      );
      await Promise.all(formattedAllItems.map(postDataCotizacion));
    }
    setShowTramoModalServicio(false);
    await getDetalleData();
    setLoading(false);
  };
  const [visible, setVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState(null);
  const [typeOfAdd, setTypeOfAdd] = useState("");

  // Hook useEffect para actualizar las tarifas mensuales de los productos de arriendo
  useEffect(() => {
    // Verifica si hay datos en flattenedDataArriendo y si las opciones de moneda ya fueron obtenidas
    if (flattenedDataArriendo.length > 0 && monedaOptionsFetched) {
      // Se actualizan los datos de arriendo recalculando la tarifa mensual con metraje
      const updatedData = flattenedDataArriendo.map((item) => {
        const updatedItem = { ...item };
        // Calcula la tarifa mensual del arriendo en función del metraje y la moneda
        calculateTarifaMensualWithMetraje(updatedItem, monedaOptions);
        return updatedItem;
      });

      // Si los datos actualizados son distintos a los originales, se actualiza el estado
      if (!isEqual(updatedData, flattenedDataArriendo)) {
        setFlattenedDataArriendo(sortDataByProductAndSubProduct(updatedData));
      }
    }

    // Se extraen los productos únicos de arriendo
    const uniqueProducts = [];
    const descriptions = new Set();

    // Se filtran solo los productos que no se han agregado previamente
    flattenedDataArriendo.forEach((item) => {
      if (item.relacion === "producto" && !descriptions.has(item.descripcion)) {
        uniqueProducts.push(item);
        descriptions.add(item.descripcion);
      }
    });

    // Se actualiza el estado con los productos únicos
    setProducts(uniqueProducts);

    // Se ejecuta este efecto cada vez que cambian flattenedDataArriendo o monedaOptionsFetched
  }, [flattenedDataArriendo, monedaOptionsFetched]);

  // Hook useEffect para calcular el subtotal de arriendo
  useEffect(() => {
    // Verifica si hay datos en flattenedDataArriendo antes de calcular el subtotal
    if (flattenedDataArriendo.length > 0) {
      const subtotalArriendo = calculateSubtotal(flattenedDataArriendo);
      // Se actualiza el estado con el subtotal calculado
      setSubtotalArriendo(subtotalArriendo);
    }
    // Se ejecuta cada vez que cambian los datos de flattenedDataArriendo
  }, [flattenedDataArriendo]);

  // Hook useEffect para actualizar las tarifas mensuales de los servicios
  useEffect(() => {
    // Verifica si hay datos en servicios y si las opciones de moneda ya fueron obtenidas
    if (servicios.length > 0 && monedaOptionsFetched) {
      // Se actualizan los datos de servicios recalculando la tarifa mensual
      const updatedData = servicios.map((item) => {
        const updatedItem = { ...item };
        // Calcula la tarifa mensual de los servicios en función de la moneda y el subtotal del arriendo
        calculateTarifaMensualServicios(
          updatedItem,
          monedaOptions,
          flattenedDataArriendo,
          subtotalArriendo
        );
        return updatedItem;
      });
      // Si los datos actualizados son distintos a los originales, se actualiza el estado
      if (!isEqual(updatedData, servicios)) {
        setServicios(sortDataByProductAndSubProduct(updatedData));
      }
    }
    // Se ejecuta cada vez que cambian servicios, monedaOptionsFetched o subtotalArriendo
  }, [servicios, monedaOptionsFetched, subtotalArriendo]);

  useEffect(() => {
    if (servicios.length > 0) {
      const subtotalArriendo = calculateSubtotal(servicios);
      setSubtotalServicios(subtotalArriendo);
    }
  }, [servicios]);

  useEffect(() => {
    if (serviciosUnicos.length > 0 && monedaOptionsFetched) {
      const updatedData = serviciosUnicos.map((item) => {
        const updatedItem = { ...item };
        calculateTarifaMensualServiciosUnicos(updatedItem, monedaOptions);
        return updatedItem;
      });
      if (!isEqual(updatedData, serviciosUnicos)) {
        setServiciosUnicos(sortDataByProductAndSubProduct(updatedData));
      }
    }
  }, [serviciosUnicos, monedaOptionsFetched]);

  // ----------- DOCUMENTOS DE COBRO SELECCIONADOS ------------
  const selectedCobroOptions = useMemo(() => {
    return [
      ...new Set([
        ...(flattenedDataArriendo?.map((item) => item.cobro) || []),
        ...(servicios?.map((item) => item.cobro) || []),
        ...(serviciosUnicos?.map((item) => item.cobro) || []),
      ]),
    ].filter((cobro) =>
      cobroOptionsFlattened.some((option) => option.value === cobro)
    );
  }, [flattenedDataArriendo,servicios,serviciosUnicos,cobroOptionsFlattened,]);

  function isEqual(objA, objB) {
    return JSON.stringify(objA) === JSON.stringify(objB);
  }

  //abrir dialogo de agregar servicio
  const openDialog = (typeOfAdd) => {
    setTypeOfAdd(typeOfAdd);
    setFilteredSubproductos([]);
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setshowProductForm2(false);
    setVisible(true);
    
    // Si solo hay un producto, lo seleccionamos automáticamente
    if (products.length === 1) {
      setSelectedProduct(products[0]);
      handleAddToProduct(products[0], typeOfAdd);
      setshowProductForm2(true);
    } else {
      setSelectedProduct(null);
    }
  };

  //cerrar dialogo de agregar servicio
  const closeDialog = () => {
    setFilteredSubproductos([]);
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setVisible(false);
  };

  const closeDialogSubproducto = () => {
    setMetrajeSubproductoAdicional(1);
    setSubProductoAdicional(null);
    setSelectedProduct(null);
    setshowProductForm2(false);
    setFilteredSubproductos([]);
    setFilteredServicios([]);
    setSelectedServicios([]);
    setRawServicios([]);
    setVisible(false);
  };
  //cambio de producto en dialogo de agregar servicio
  const handleProductChange = (e) => {
    setSelectedServicios([]);
    setRawServicios([]);
    setSelectedProduct(e.value);
    setshowProductForm2(false);
  };

  const handleshowProductForm2 = async () => {
    if (selectedProduct) {
      await handleAddToProduct(selectedProduct, typeOfAdd);
      setshowProductForm2(true);
    }
  };

  const handleAddToProduct = async (producto, typeOfAdd) => {
    await fetchAgregado(typeOfAdd, producto.id, producto.id_empresa);
  };

  const buildServiciosUrl = (idEmpresa) => {
    return `${baseUrl}getServiciosByIdEmpresa?idEmpresa=${idEmpresa}`;
  };

  const buildTiposSubproductosUrl = (idEmpresa) => {
    return `${baseUrl}getSubproductosByIdEmpresa?idEmpresa=${idEmpresa}`;
  };

  const [filteredServicios, setFilteredServicios] = useState([]);
  const [rawServicios, setRawServicios] = useState([]);
  const [selectedServicios, setSelectedServicios] = useState([]);
  const [filteredSubproductos, setFilteredSubproductos] = useState([]);
  const [subProductoAdicional, setSubProductoAdicional] = useState(null);
  const [metrajeSubproductoAdicional, setMetrajeSubproductoAdicional] = useState(0);

  const handleServicioSelectionChange = (e) => {setSelectedServicios(e.value);};

  /**
   * Obtiene datos de servicios y subproductos para agregarlos a la cotización.
   * @param {string} typeOfAdd - Tipo de agregado (producto o servicio).
   * @param {number} idProducto - ID del producto relacionado (si aplica).
   * @param {number} idEmpresa - ID de la empresa a la que pertenecen los servicios/subproductos.
   * @throws {Error} Lanza un error si la solicitud falla.
   */
  const fetchAgregado = async (typeOfAdd, idProducto, idEmpresa) => {
    try {
      setLoading(true); // Activa el estado de carga mientras se obtienen los datos
      let dataServicios = [];

      // Construye la URL para obtener los servicios de la empresa
      const urlServicios = buildServiciosUrl(idEmpresa);
      // Realiza la solicitud a la API y almacena los servicios obtenidos
      dataServicios = await fetchData(urlServicios);

      // Si la respuesta contiene un array de servicios, se asigna correctamente
      if (Array.isArray(dataServicios.servicios)) {
        dataServicios = dataServicios.servicios;
      }

      // Almacena la lista completa de servicios obtenidos
      setRawServicios(dataServicios);

      // Filtra los servicios que están marcados como "incluidos"
      setFilteredServicios(
        dataServicios.filter((servicio) => servicio.incluido)
      );

      // Construye la URL para obtener los tipos de subproductos de la empresa
      const urlTiposSubproducto = buildTiposSubproductosUrl(idEmpresa);

      // Realiza la solicitud a la API para obtener los tipos de subproductos
      const [tiposSubproductosResponse] = await Promise.all([
        fetchData(urlTiposSubproducto),
      ]);

      // Si la respuesta contiene un array de subproductos, se almacena en el estado
      if (Array.isArray(tiposSubproductosResponse.subproductos)) {
        setFilteredSubproductos(tiposSubproductosResponse.subproductos);
      }

      setLoading(false); // Desactiva el estado de carga tras completar la solicitud
    } catch (error) {
      console.error(error); // Captura y muestra en consola cualquier error
      setLoading(false); // Asegura que el indicador de carga se detenga en caso de error
    }
  };

  /**
   * Maneja la adición de un subproducto o servicio adicional a la cotización.
   * @param {string} typeOfAdd - Tipo de adición ("subproducto" o "servicio").
   */
  const handleAñadirAdicional = async (typeOfAdd) => {
    setLoading(true);
    // Si se va a agregar un subproducto, se valida que los campos obligatorios estén llenos
    if (typeOfAdd === "subproducto") {
      if (!subProductoAdicional || !metrajeSubproductoAdicional) {
        setLoading(false);
        alert("Necesita llenar todos los campos");
        return;
      }
    }

    /**
     * Convierte una fecha en formato válido "YYYY-MM-DD".
     * @param {string} dateInput - Fecha de entrada.
     * @return {string|null} Fecha formateada o null si es inválida.
     */
    function formatDateTramo(dateInput) {
      let formattedDate = moment(dateInput, dateFormats, true);

      if (!formattedDate.isValid()) {
        console.error("Invalid date format");
        return null; // Manejo de error en caso de fecha inválida
      }

      return formattedDate.format("YYYY-MM-DD");
    }

    /**
     * Crea un nuevo subproducto con los datos seleccionados.
     * @return {Object} Objeto representando el nuevo subproducto.
     */
    const createNewSubproducto = (index) => {
      return {
        ...subProductoAdicional,
        descripcion: `${subProductoAdicional.descripcion} - ${selectedProduct.descripcion}`,
        tarifa_cliente: subProductoAdicional.tarifa_base,
        relacion: "subproducto",
        desde: formatDateTramo(desde),
        hasta: formatDateTramo(hasta),
        descuento: 0,
        tramo: null,
        tipo: "Adicional",
        cantidad: metrajeSubproductoAdicional,
        cobro: "Factura Afecta",
        contrato: true,
        consolidado: false,
        agrupamiento: 0,
        id_elemento: subProductoAdicional.id,
        id: null,
        id_cotizacion: idCotizacion,
        metraje: metrajeSubproductoAdicional,
        codigo_producto: selectedProduct.codigo_producto,
      };
    };

    /**
     * Actualiza los detalles de un servicio para adaptarlo al formato de cotización.
     * @param {Object} service - Objeto representando el servicio a actualizar.
     * @return {Object} Servicio actualizado con los valores necesarios.
     */
    const updateServiceDetails = (service) => {
      // Encontrar el arriendo asociado
      const arriendoAsociado = flattenedDataArriendo.find(
        (item) => item.descripcion === selectedProduct.descripcion
      );

      return {
        ...service,
        relacion: "servicio",
        cobro: "Factura Afecta",
        desde: arriendoAsociado ? formatDateTramo(arriendoAsociado.desde) : formatDateTramo(desde),
        hasta: arriendoAsociado ? formatDateTramo(arriendoAsociado.hasta) : formatDateTramo(hasta),
        descuento: 0,
        tramo: null,
        tipo: "Adicional",
        contrato: true,
        consolidado: false,
        agrupamiento: 0,
        id_elemento: service.id,
        id: null,
        id_cotizacion: idCotizacion,
      };
    };

    /**
     * Maneja la adición de "Obra Civil" a la cotización si existe en los servicios.
     * @param {Array} servicesList - Lista de servicios.
     * @return {Object|null} Objeto con la información de "Obra Civil" o null si no se encuentra.
     */
    const handleObraCivil = (servicesList) => {
      const obraCivil = servicesList.find(
        (service) => service.descripcion === "Obra Civil"
      );

      if (obraCivil) {
        // Encontrar el arriendo asociado
        const arriendoAsociado = flattenedDataArriendo.find(
          (item) => item.descripcion === selectedProduct.descripcion
        );

        obraCivil.relacion = "servicio";
        obraCivil.tarifa_base = 0;
        obraCivil.tarifa_cliente = 0;
        obraCivil.tipo = "Adicional";
        obraCivil.desde = arriendoAsociado ? formatDateTramo(arriendoAsociado.desde) : formatDateTramo(desde);
        obraCivil.hasta = arriendoAsociado ? formatDateTramo(arriendoAsociado.hasta) : formatDateTramo(hasta);
        obraCivil.descripcion = `Obra Civil - ${selectedProduct.descripcion}`;
        obraCivil.codigo_producto = selectedProduct.codigo_producto;
        return obraCivil;
      }
      return null;
    };

    /**
     * Maneja la adición de "Habilitacion Fibra" a la cotización si existe en los servicios.
     * @param {Array} servicesList - Lista de servicios.
     * @return {Object|null} Objeto con la información de "Habilitación Fibra" o null si no se encuentra.
     */
    const handleHabilitacionFibra = (servicesList) => {
      const habilitacionFibra = servicesList.find(
        (service) => service.descripcion === "Habilitacion Fibra"
      );

      if (habilitacionFibra) {
        // Encontrar el arriendo asociado
        const arriendoAsociado = flattenedDataArriendo.find(
          (item) => item.descripcion === selectedProduct.descripcion
        );

        habilitacionFibra.relacion = "servicio";
        habilitacionFibra.tarifa_base = 0;
        habilitacionFibra.tarifa_cliente = 0;
        habilitacionFibra.descripcion = `Habilitacion Fibra - ${selectedProduct.descripcion}`;
        habilitacionFibra.desde = arriendoAsociado ? formatDateTramo(arriendoAsociado.desde) : formatDateTramo(desde);
        habilitacionFibra.hasta = arriendoAsociado ? formatDateTramo(arriendoAsociado.hasta) : formatDateTramo(hasta);
        habilitacionFibra.codigo_producto = selectedProduct.codigo_producto;
        return habilitacionFibra;
      }
      return null;
    };

    // Manejo de la adición de un subproducto
    if (typeOfAdd === "subproducto") {
      const newSubproducto = {
        ...createNewSubproducto(flattenedDataArriendo.length),
        agrupamiento: 0,
      };

      // Agrega "Obra Civil" si es necesario
      const obraCivil =
        handleObraCivil(serviciosUnicos) || handleObraCivil(rawServicios);

      if (
        obraCivil &&
        !serviciosUnicos.some(
          (item) => item.descripcion === obraCivil.descripcion
        )
      ) {
        const newObra = updateServiceDetails(obraCivil);
        serviciosUnicos.push(newObra);
      }

      // Envía los datos a la API
      await Promise.all([postDataCotizacion({ ...newSubproducto })]);
      await Promise.all(serviciosUnicos.map(postDataCotizacion));
      await getDetalleData();
    } else { // Manejo de la adición de servicios adicionales
      // Encontrar el arriendo asociado
      const arriendoAsociado = flattenedDataArriendo.find(
        (item) => item.descripcion === selectedProduct.descripcion
      );

      const updatedServicios = selectedServicios.map((servicio) => ({
        ...servicio,
        descripcion: `${servicio.descripcion} - ${selectedProduct.descripcion}`,
        tarifa_cliente: servicio.tarifa_base,
        relacion: "servicio",
        desde: arriendoAsociado ? formatDateTramo(arriendoAsociado.desde) : formatDateTramo(desde),
        hasta: arriendoAsociado ? formatDateTramo(arriendoAsociado.hasta) : formatDateTramo(hasta),
        descuento: 0,
        tramo: null,
        tipo: "Adicional",
        cantidad: 0,
        cobro:
          ["Gasto Comun", "Agua", "Electricidad"].includes(servicio.descripcion)
            ? "Nota de Cobro"
            : "Factura Afecta",
        contrato: true,
        consolidado: false,
        agrupamiento: 0,
        id_elemento: servicio.id,
        id: null,
        id_cotizacion: idCotizacion,
        codigo_producto: selectedProduct.codigo_producto,
      }));

       // Verifica si los servicios ya están agregados (validación robusta por claves)
      const buildKey = (s) => `${s.id_elemento}|${s.codigo_producto || ""}`;
      const existingKeys = new Set((servicios || []).map(buildKey));

      const duplicateServicios = updatedServicios.filter((us) =>
        existingKeys.has(buildKey(us))
      );

      if (duplicateServicios.length > 0) {
        const duplicateDescriptions = duplicateServicios
          .map((servicio) => servicio.descripcion)
          .join(", ");
        alert(
          `El producto ya tiene estos servicios asociados: ${duplicateDescriptions}`
        );
        setLoading(false);
        return;
      }

      // Si hay servicios de "Internet", se añade "Habilitación Fibra"
      const hasInternet = updatedServicios.some((servicio) =>
        servicio.descripcion.includes("Internet")
      );

      if (hasInternet) {
        const habilitacionFibra =
          handleHabilitacionFibra(serviciosUnicos) ||
          handleHabilitacionFibra(rawServicios);

        if (
          habilitacionFibra &&
          !serviciosUnicos.some(
            (item) => item.descripcion === habilitacionFibra.descripcion
          )
        ) {
          const newHabilitacion = updateServiceDetails(habilitacionFibra);
          serviciosUnicos.push(newHabilitacion);
        }
      }

      // Envía los datos a la API
      await Promise.all(updatedServicios.map(postDataCotizacion));
      await Promise.all(serviciosUnicos.map(postDataCotizacion));
      await getDetalleData();
    }

    setLoading(false);
    closeDialog(); // Cierra el cuadro de diálogo después de completar la acción
  };

  /**
   * Construye la URL para verificar si hay datos faltantes en la información del cliente.
   * @param {number} idCliente - ID del cliente a consultar.
   * @return {string} URL para obtener la información faltante del cliente.
   */
  const buildCheckDatosFaltantesCliente = (idCliente) => {
    return `${baseUrl}getInformacionFaltanteByIdCliente?idCliente=${idCliente}`;
  };

  // const getInformacionClienteById = (idCliente) => {
  //   return `${baseUrl}getInformacionClienteById?idCliente=${idCliente}`;
  // };

  /**
   * Verifica si el cliente tiene información faltante antes de cerrar el contrato.
   * - Si falta información, redirige al usuario a completarla.
   * - Si no falta información, permite proceder con el cierre del contrato.
   */
  const checkDatosFaltantesCliente = async () => {
    try {
      setLoading(true);
      //await guardarCotizacion();

      // Realiza la solicitud para obtener la información faltante del cliente
      const response = await fetch(buildCheckDatosFaltantesCliente(idCliente));
      const data = await response.json();

      // Si la respuesta indica que falta información
      if (data?.faltaInformacion && data.faltaInformacion.length > 0) {
        // Verifica si faltan datos específicos (contactos, representante legal, dirección)
        if (
          !shouldRenderContactos(data.faltaInformacion) &&
          !shouldRenderRepresentanteLegal(data.faltaInformacion) &&
          !shouldRenderDireccion(data.faltaInformacion)
        ) {
          // Si no faltan estos datos específicos, permite cerrar el contrato
          setShowCerrarContrato(true);
        } else {
          // Si falta información importante, muestra una alerta y abre el diálogo
          alert("Falta información: Será redirigido para completar la información del cliente, una vez terminado puede volver a cerrar el contrato");
          setShowDialog(true);
        }
      } else {
        setShowCerrarContrato(true);// Si no falta información, permite cerrar el contrato
      }
    } catch (error) {
      console.error("Error al verificar datos faltantes:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ha ocurrido un error al verificar los datos del cliente",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTerminar = async () => {
    setShowVencimientoDialog(true);
  };

  const handleRechazar = () => {
    setShowRechazarDialog(true);
  };

  const confirmarRechazo = async () => {
    if (!observacion.trim()) {
      alert("Por favor, ingrese el motivo del rechazo");
      return;
    }

    try {
      setLoading(true);
      await guardarCotizacion();

      const cot = await buildCotizacionData(idCotizacion);
      const fechaFormateada = moment(cot.vencimiento).format("YYYY-MM-DD");
      
      // Construir URL para rechazar cotización
      await updateCotizacion(
        idCotizacion,
        idCliente,
        6, // Estado de la cotización a Revision
        sessionStorage.getItem("usuario_id"), // ID del usuario que guarda la cotización
        desde,
        hasta,
        0,
        observacion,
        fechaFormateada // ← La fecha ya se está pasando aquí correctamente
      );
      
      alert("La cotización se ha rechazado correctamente");
      setLoading(false);
      setShowRechazarDialog(false);
      setObservacion("");
      navigate("/revision");
    } catch (error) {
      console.error("Error al rechazar", error);
      alert("Error al rechazar la cotización");
    } finally {
      setLoading(false);
    }
  };

  const cancelarRechazo = () => {
    setShowRechazarDialog(false);
    setObservacion("");
  };

  // Funciones para el diálogo de vencimiento
  const cancelarVencimiento = () => {
    setShowVencimientoDialog(false);
    setFechaVencimiento(null);
  };

  const confirmarVencimiento = async () => {
    if (!fechaVencimiento) {
      alert("Por favor, seleccione una fecha de vencimiento");
      return;
    }
    
    try {
      // Formatear la fecha para enviarla al backend
      const fechaFormateada = moment(fechaVencimiento).format("YYYY-MM-DD");
      
      setShowVencimientoDialog(false);
      setLoading(true);
      
      await guardarCotizacion();
      
      await updateCotizacion(
        idCotizacion,
        idCliente,
        3, // Estado de la cotización a Revision
        sessionStorage.getItem("usuario_id"), // ID del usuario que guarda la cotización
        desde,
        hasta,
        0,
        null, // Usar la observación existente en lugar de null
        fechaFormateada // Usar la fecha de vencimiento seleccionada
      );

      setLoading(false);
      navigate("/revision", {
        state: {
          toast: {
            severity: 'success',
            summary: 'Éxito',
            detail: 'La cotización se ha guardado con éxito',
            life: 3000
          }
        }
      });
    } catch (error) {
      console.error("Error terminar", error);
      alert("Error al finalizar la cotización");
    } finally {
      setLoading(false);
    }
  };
  /**
   * Verifica si faltan datos de contacto en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato de contacto, `false` en caso contrario.
   */
  const shouldRenderContactos = (faltaInformacion) => {
    const fields = ["nombre_contacto","tipo_contacto","telefono_contacto","correo_contacto",];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos de contacto está en la lista de información faltante
  };

  /**
   * Verifica si faltan datos del representante legal en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato del representante legal, `false` en caso contrario.
   */
  const shouldRenderRepresentanteLegal = (faltaInformacion) => {
    const fields = ["rut_representante_legal","nombre_representante_legal","correo_representante_legal","telefono_representante_legal",];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos del representante legal está en la lista de información faltante
  };

  /**
   * Verifica si faltan datos de dirección en la información del cliente.
   * @param {Array} faltaInformacion - Lista de campos faltantes.
   * @return {boolean} `true` si falta algún dato de dirección, `false` en caso contrario.
   */
  const shouldRenderDireccion = (faltaInformacion) => {
    const fields = ["direccion_domicilio", "tipo_domicilio"];
    return fields.some((field) => faltaInformacion.includes(field));// Retorna true si alguno de los campos de dirección está en la lista de información faltante
  };

  /**
   * Maneja la redirección del usuario para agregar un nuevo producto a la cotización.
   * - Muestra una confirmación antes de proceder.
   * - Redirige al usuario a la pantalla de selección de productos si confirma.
   */
  const handleAgregarProducto = () => {
    const userConfirmed = window.confirm("Serás redirigido para poder seleccionar un producto nuevo, asegúrate de guardar antes de salir de esta página.");

    if (userConfirmed) {
      // Obtiene los parámetros de la URL actual
      const searchParams = new URLSearchParams(location.search);
      const idCliente = parseInt(searchParams.get("idCliente"));
      const idCotizacion = parseInt(searchParams.get("idCotizacion"));

      const desdeParam = searchParams.get("desde");
      const desde = desdeParam || moment().add(1, "day").format("YYYY-MM-DD");
      const hasta = searchParams.get("hasta");

      // Redirige al usuario a la página para agregar un producto con los mismos parámetros
      navigate(`/agregarProducto?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desde}&hasta=${hasta}`);
    }
  };

  /**
   * Obtiene los datos de un cliente según su ID.
   * - Realiza una solicitud a la API para recuperar la información del cliente.
   * - Si la respuesta es exitosa, actualiza el estado con los datos del cliente.
   * - En caso de error, muestra el error en la consola.
   */
  const fetchDataCliente = async (idCli = idCliente) => {
    try {
      const response = await fetch(`${baseUrl}getClienteById?idCliente=${idCli}`);
      if (!response.ok) {
        throw new Error(`Network response was not ok. Status: ${response.status}`);
      }
      const data = await response.json();
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  // Referencia para el overlay (posiblemente un modal o una ventana emergente)
  const overlayRef = useRef(null);
  /**
   * Maneja la modificación de la asignación de una cotización.
   * - Muestra una confirmación antes de proceder.
   * - Si el usuario confirma, realiza una solicitud para cambiar el estado de la asignación.
   * - Si la solicitud es exitosa, recarga la página para reflejar los cambios.
   * - En caso de error, muestra un mensaje en la alerta y en la consola.
   */
  const monedaUf = monedaOptions.find((m) => m.codigo === "UF");
  const [valorUf, setValorUf] = useState(null);

  useEffect(() => {
    const monedaUf = monedaOptions.find((m) => m.codigo === "UF");
    setValorUf(monedaUf ? monedaUf.tipoCambio : "No disponible");
  }, [monedaOptions]);

  // ——————————————————————————————
  // BTN MODIFICAR ASIGNACION
  // ——————————————————————————————
  const handleShowModificarAsignacion = async () => {
    // Muestra una confirmación al usuario antes de proceder con la modificación
    const confirm = window.confirm(
      "¿Estás seguro de que deseas modificar la asignación?\n" +
      "\n" +
      "Al continuar, la asignación actual se marcará como anulada y se enviará a la lista de recotizaciones.\n" +
      "Se creará un folio hijo a partir de esta asignación, el cual se enviará a cotización para que puedas realizar las modificaciones necesarias."
    );

    if (confirm) {
      setLoading(true);
      try {
        // Obtiene el ID del usuario desde sessionStorage
        const idCreador = sessionStorage.getItem("usuario_id");

        // Si no hay un usuario identificado, lanza un error
        if (!idCreador) {
          throw new Error("Usuario no identificado. Inicia sesión para continuar.");
        }

        const responseRecotizar = await fetch(`${baseUrl}recotizar?idCotizacion=${idCotizacion}&idCreador=${idCreador}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Convierte la respuesta en JSON
        const result = await responseRecotizar.json();

        // Si la respuesta es positiva, muestra una alerta de éxito y recarga la página
        if (result.respuesta) {
          alert("La asignación pasará a estado de recotización y podrá ser modificada.");
          setLoading(false);
          
          // Usa el nuevo idCotizacion si viene en la respuesta, si no, usa el actual
          const newIdCotizacion = result.idCotizacionHijo || idCotizacion;
          const baseUrl = window.location.href.split("/#/")[0];
          const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${newIdCotizacion}&desde=${desde}&hasta=${hasta}`;
          const fullUrl = `${baseUrl}/#${urlAVolver}`;
          window.location.href = fullUrl;
          window.location.reload();
          
        } else {
          // Si hay un error en la respuesta, lo muestra en una alerta
          setLoading(false);
          alert(`Error: ${result.mensaje}`);
        }
      } catch (error) {
        // Captura errores y los muestra en la consola y en una alerta
        setLoading(false);
        console.error("Error in handleShowModificarAsignacion:", error);
        alert(`Error: ${error.message}`);
      }
    }
  };

    // ——————————————————————————————
  // BTN RENOVAR ASIGNACION
  // ——————————————————————————————
  const handleShowRenovarAsignacion = () => {
    const confirm = window.confirm(
      "¿Estás seguro de que deseas renovar la asignación?\n" +
      "\n" +
      "Esta acción creará una nueva cotización basada en la asignación actual y comenzará a regir desde la fecha de término de la asignación vigente."
    );
    if (confirm) {
      setShowRenovarDialog(true);
    }else{
      return;
    }
  };

  const cancelarRenovacion = () => {
    setShowRenovarDialog(false);
    setObservacionRenovacion("");
    setHastaRenovacion(null);
  };



  // Cuenta cuántos ítems hay de cada tipo de documento
  const cobroCounts = useMemo(() => {
    const allItems = [
      ...flattenedDataArriendo,
      ...servicios,
      ...serviciosUnicos
    ];
    return allItems.reduce((acc, item) => {
      acc[item.cobro] = (acc[item.cobro] || 0) + 1;
      return acc;
    }, {});
  }, [flattenedDataArriendo, servicios, serviciosUnicos]);

  const columnBodyTemplate = (rowData, column) => {
    const value = rowData[column.field];
    if (!value) return ""; // Si está vacío o null
    const number = parseFloat(value.replace(",", "."));
    return isNaN(number) ? value : `${number.toFixed(2)} UF`;
  };

  useEffect(() => {
    if (!subProductoAdicional && Array.isArray(filteredSubproductos) && filteredSubproductos.length > 0) {
      setSubProductoAdicional(filteredSubproductos[0]);
    }
  }, [filteredSubproductos, subProductoAdicional]);

  return (
    <>
      {/* {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <> */}
          <div className="card">
            <>
              <Toast ref={toast} />
              
              <OverlayPanel ref={overlayRef} className="p-4">
                <h5 className="text-sm font-semibold text-gray-700 mb-2">
                  Información del Cliente
                </h5>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>
                    <strong>RUT:</strong> {cliente?.rut}
                  </li>
                  <li>
                    <strong>Razón Social:</strong> {cliente?.razon_social || "—"}
                  </li>
                  <li>
                    <strong>Alias:</strong> {cliente?.alias}
                  </li>
                  <li>
                    <strong>Activo:</strong> {cliente?.activo ? "Sí" : "No"}
                  </li>
                </ul>
                <h6 className="text-sm font-semibold text-gray-700 mt-3">
                  Contactos:
                </h6>
                <ul className="text-sm text-gray-600 space-y-1">
                  {(cliente?.contactos || []).map((contacto) => (
                    <li key={contacto?.id}>
                      <strong>{contacto?.nombre}:</strong>{" "}
                      {contacto?.correo || "Sin correo"}
                    </li>
                  ))}
                </ul>
              </OverlayPanel>

              <div className="p-4 bg-white shadow-md rounded-lg max-h- overflow-y-auto">
                <h2 className="text-xl font-semibold text-gray-900">
                  Cotización: {idCotizacion}
                </h2>

                <div className="flex flex-row gap-2">
                  <h5 className="text-base font-medium text-gray-800">
                    Cliente:{" "}
                    <span
                      className="text-blue-500 ml-1 cursor-pointer hover:underline"
                      onClick={(e) => overlayRef.current.toggle(e)}
                    >
                      {cliente?.razon_social?.toUpperCase() || ""}
                    </span>
                  </h5>
                </div>

                {/* Products List */}
                <div>
                  <div className="flex flex-wrap gap-2">
                    <h5 className="text-base font-medium text-gray-800">
                      Productos:{" "}
                      <span className="text-gray-700">
                        {[
                          ...new Set(
                            carro
                              .filter((item) => item.relacion === "producto")
                              .map((item) => item.descripcion)
                          ),
                        ].join(" | ")}
                      </span>
                    </h5>
                  </div>
                </div>
                <div>
                  <div className="flex flex-wrap gap-2">
                    <h5 className="text-base font-medium text-gray-800">
                      Empresa Arrendadora:{" "}
                      <span className="ml-1">{cotizacion?.empresa}</span>
                    </h5>
                  </div>
                </div>
                {/* <div>
                  <div className="flex flex-wrap gap-2">
                    <h5 className="text-base font-medium text-gray-800">
                      Valor Uf :{" "}
                      <span className="ml-1">{valorUf}</span>
                    </h5>
                  </div>
                </div> */}

                {cotizacion?.estado?.estado === "ASIGNACIÓN" && (
                  <div>
                    <div className="flex flex-wrap gap-2">
                      <h5 className="text-base font-medium text-gray-800">
                        Estado:{" "}
                        <span className="ml-1">{cotizacion?.estado?.estado}</span>
                      </h5>
                    </div>
                  </div>
                )}
              </div>

                    <ArriendoDataTable
                      flattenedDataArriendo={flattenedDataArriendo}
                      setFlattenedDataArriendo={setFlattenedDataArriendo}
                      loading={loading}
                      cotizacion={cotizacion}
                      desde={desde}
                      hasta={hasta}
                      idCotizacion={idCotizacion}
                      idCliente={idCliente}
                      servicios={servicios}
                      setServicios={setServicios}
                      setDesde={setDesde}
                      setHasta={setHasta}
                      setLoading={setLoading}
                      handleTablaChange={handleTablaChange}
                      postUpdateDataCotizacion={postUpdateDataCotizacion}
                      updateCotizacion={updateCotizacion}
                      handleNewTramoArriendo={handleNewTramoArriendo}
                      handleBorrarLinea={handleBorrarLinea}
                      // handleMaskChange={handleMaskChange}
                      empresas={empresas}
                      handleTramoConfirmationArriendo={handleTramoConfirmationArriendo}
                      showProductForm2={showProductForm2}
                      setshowProductForm2={setshowProductForm2}
                      handleProductChange={handleProductChange}
                      handleshowProductForm2={handleshowProductForm2}
                      handleAddToProduct={handleAddToProduct}
                      cobroOptionsFlattened={cobroOptionsFlattened}
                      monedaOptions={monedaOptions}
                      subtotalArriendo={subtotalArriendo}
                      products={products}
                      showTramoModalArriendo={showTramoModalArriendo}
                      setShowTramoModalArriendo={setShowTramoModalArriendo}
                      nombreCuadro={nombreCuadro}
                      setNombreCuadro={setNombreCuadro}
                      tramos={tramos}
                      tramoCounter={tramoCounter}
                      selectFechaTramo={selectFechaTramo}
                      dateFormats={dateFormats}
                    />

                    {servicios.length > 0 && (
                      <ServiciosDataTable
                        servicios={servicios}
                        loading={loading}
                        cotizacion={cotizacion}
                        desde={desde}
                        hasta={hasta}
                        idCotizacion={idCotizacion}
                        idCliente={idCliente}
                        flattenedDataArriendo={flattenedDataArriendo}
                        setLoading={setLoading}
                        setDesde={setDesde}
                        setHasta={setHasta}
                        handleTablaChange={handleTablaChange}
                        postUpdateDataCotizacion={postUpdateDataCotizacion}
                        updateCotizacion={updateCotizacion}
                        //handleMaskChange={handleMaskChange}
                        handleNewTramoServicio={handleNewTramoServicio}
                        handleBorrarLinea={handleBorrarLinea}
                        cobroOptionsServicios={cobroOptionsServicios}
                        monedaOptions={monedaOptions}
                        handleTramoConfirmationServicio={handleTramoConfirmationServicio}
                        showTramoModalServicio={showTramoModalServicio}
                        setShowTramoModalServicio={setShowTramoModalServicio}
                        nombreCuadro={nombreCuadro}
                        setNombreCuadro={setNombreCuadro}
                        tramos={tramos}
                        tramoCounter={tramoCounter}
                        selectFechaTramo={selectFechaTramo}
                        subtotalServicios={subtotalServicios}
                      />
                    )}

                    {serviciosUnicos.length > 0 && (
                      <ServiciosUnicosDataTable
                        serviciosUnicos={serviciosUnicos}
                        loading={loading}
                        cotizacion={cotizacion}
                        handleTablaChange={handleTablaChange}
                        //handleMaskChange={handleMaskChange}
                        handleNewTramoCuota={handleNewTramoCuota}
                        handleBorrarLinea={handleBorrarLinea}
                        handleTramoConfirmacionCuota={handleTramoConfirmacionCuota}
                        cobroOptionsServiciosUnicos={cobroOptionsServiciosUnicos}
                        monedaOptions={monedaOptions}
                        showTramoModalUnico={showTramoModalUnico}
                        setShowTramoModalUnico={setShowTramoModalUnico}
                        nombreCuadro={nombreCuadro}
                        cuotas={cuotas}
                        setCuotas={setCuotas}
                        maxAmountOfCuotas={maxAmountOfCuotas}
                        itemCuotas={itemCuotas}
                      />
                    )}

                    {/* BOTONES */}
                    <CotizacionActions
                      cotizacion={cotizacion}
                      loading={loading}
                      loadingAsig={loadingAsig}
                      handleAgregarProducto={handleAgregarProducto}
                      openDialog={openDialog}
                      handleShowResumenMensual={handleShowResumenMensual}
                      guardarCotizacion={guardarCotizacion}
                      checkDatosFaltantesCliente={checkDatosFaltantesCliente}
                      handleTerminar={handleTerminar}
                      handleRechazar = {handleRechazar}
                      cerrarContrato={cerrarContrato}
                      diasAviso={diasAviso}
                      setDiasAviso={setDiasAviso}
                      cantidadDiasAvisoContrato={cantidadDiasAvisoContrato}
                      diasFirma={diasFirma}
                      setDiasFirma={setDiasFirma}
                      cantidadDiasFirmaContrato={cantidadDiasFirmaContrato}
                      showCerrarContrato={showCerrarContrato}
                      setShowCerrarContrato={setShowCerrarContrato}
                      handleShowModificarAsignacion={handleShowModificarAsignacion}
                      handleShowRenovarAsignacion={handleShowRenovarAsignacion}
                      documentos={selectedCobroOptions}
                      detallesCobro={detallesCobro}
                      setDetallesCobro={setDetallesCobro}
                      handleTablaChange={handleTablaChange}
                      cobroCounts={cobroCounts} 
                      flattenedDataArriendo={flattenedDataArriendo}
                      servicios = {servicios}
                      serviciosUnicos = {serviciosUnicos}
                      setFlattenedDataArriendo={setFlattenedDataArriendo}
                      setServicios={setServicios}
                      setServiciosUnicos={setServiciosUnicos}
                    />
        
              {/* FOOTER */}
              {/* <div className="col-12 md:col-12">
                <Panel header="TOTAL">
                  <div className="grid text-right">
                    <div className="col-10">SUBTOTAL</div>
                    <div className="col-2">
                      <span className="pink-color">
                        {subtotal.toLocaleString("en-US").replace(".", ",")} UF
                      </span>
                    </div>

                    <div className="col-10">
                      <span>I.V.A</span>
                    </div>
                    <div className="col-2">
                      <span className="pink-color">
                        {iva.toLocaleString("en-US").replace(".", ",")} UF
                      </span>
                    </div>

                    <div className="col-10">
                      <span>TOTAL</span>
                    </div>
                    <div className="col-2">
                      <span className="pink-color">
                        {total.toLocaleString("en-US").replace(".", ",")} UF
                      </span>
                    </div>
                    <div className="col-10">
                      <span></span>
                    </div>

                    
                  </div>
                </Panel> 
                
              </div>*/}

              <ResumenMensualDialog
                visible={verResumenMensual}
                onHide={() => setVerResumenMensual(false)}
                loading={loading}
                matrixArray={matrixArray}
                columns={columns}
                columnBodyTemplate={columnBodyTemplate}
              />

              <Dialog
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{ width: "85vw" }}
                closable={true}
                modal
              >
                <FormCrearCliente
                  modoEdicion={true}
                  clienteData={cliente}
                  onSuccess={() => {
                    toast.current.show({
                      severity: "success",
                      summary: "Operación Exitosa",
                      detail: "El cliente ha sido guardado correctamente.",
                      life: 3000,
                    });
                    setShowDialog(false);
                    // Volver a verificar los datos después de actualizar
                  }}
                  onError={(error) => {
                    console.error("Error:", error);
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: "No se pudo actualizar el cliente. Por favor, intente nuevamente.",
                      life: 3000,
                    });
                  }}
                  onClose={() => {
                    window.location.reload();
                    setShowDialog(false);
                  }}
                  fetchData={fetchData}
                />
              </Dialog>

              <Dialog
                header="Agregar Subproducto o Servicio"
                visible={visible}
                modal
                onHide={closeDialogSubproducto}
                className="p-fluid product-dialog"
              >
                <div>
                  <h6 className="mb-3">
                      Información del Producto
                  </h6>    
                  <span className="p-float-label mt-2 mb-3">
                    <Dropdown
                      value={selectedProduct}
                      options={products}
                      onChange={handleProductChange}
                      optionLabel="descripcion"
                      placeholder="Seleccione un producto"
                      className="w-full"
                    />
                    <label htmlFor="tipoSubP">Producto</label>
                  </span>

                  {selectedProduct && !showProductForm2 && (
                    <div className="flex justify-content-center mt-4 mb-3">
                      <Button
                        icon="pi pi-arrow-right"
                        label="Continuar"
                        className="p-button-rounded p-button-primary"
                        onClick={handleshowProductForm2}
                        style={{ width: "400px" }}
                        raised
                      />
                    </div>
                  )}

                  {showProductForm2 && typeOfAdd === "subproducto" && filteredSubproductos.length > 0 && (
                    <>
                      <div>
                        <h6 className="mb-3">
                            Subproducto Adicional
                          <span className="text-sm text-gray-600 mt-1 mr-2"> 
                            (Máximo permitido: {selectedProduct.cantidad} m²)
                          </span>
                        </h6>    
                    
                        
                        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                          <span className="p-float-label" style={{ width: "100%" }}>
                            <Dropdown
                              id="tipoSubP"
                              value={subProductoAdicional}
                              onChange={(e) => setSubProductoAdicional(e.value)}
                              options={filteredSubproductos}
                              optionLabel="descripcion"
                              placeholder="Seleccione un subproducto"
                              className="w-full"
                            />
                            <label htmlFor="tipoSubP">Tipo de Subproducto</label>
                          </span>

                          <span className="p-float-label" style={{ width: "100%" }}>
                            <InputNumber
                              id="metrajeSubp"
                              value={metrajeSubproductoAdicional}
                              onChange={(e) => {
                                const newValue = Math.min(Math.max(1, e.value), selectedProduct.cantidad);
                                setMetrajeSubproductoAdicional(newValue);
                              }}
                              min={1}
                              placeholder="ingrese cantidad en metros"
                              max={selectedProduct.cantidad}
                              className="w-full"
                              inputStyle={{ width: "100%" }}
                            />
                            <label htmlFor="metrajeSubp">Metros del Subproducto Adicional</label>
                          </span>
                        </div>

                        <div className="flex justify-content-center mt-4">
                          <Button
                            icon="pi pi-plus"
                            label="Agregar"
                            className="p-button-rounded p-button-success p-button-md"
                            onClick={() => handleAñadirAdicional(typeOfAdd)}
                            disabled={subProductoAdicional === null||loading}
                            style={{ width: "400px" }}
                            raised
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {showProductForm2 && typeOfAdd === "servicio" && (
                    <>
                      <DataTable
                        value={filteredServicios}
                        selection={selectedServicios}
                        onSelectionChange={handleServicioSelectionChange}
                        className="p-datatable-gridlines"
                        showGridlines
                        dataKey="id"
                        emptyMessage="No tiene servicios asociados"
                        loading={loading}
                      >
                        <Column selectionMode="multiple" style={{ width: "3em" }} />
                        <Column field="descripcion" header={
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="pi pi-list" style={{ color: '#2196F3' }}></i>
                            Servicios
                          </div>
                        } />
                        <Column field="moneda" header={
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="pi pi-dollar" style={{ color: '#4CAF50' }}></i>
                            Moneda
                          </div>
                        } />
                        <Column field="unidad" header={
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="pi pi-chart-bar" style={{ color: '#FF9800' }}></i>
                            Unidad Medida
                          </div>
                        } />
                      </DataTable>

                      <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          label="Agregar"
                          icon="pi pi-plus"
                          onClick={() => handleAñadirAdicional(typeOfAdd)}
                          className="p-button-rounded p-button-success p-button mb-2 mt-2"
                          disabled={selectedServicios.length === 0||loading}
                          style={{ width: "400px" }}
                          raised
                        />
                      </div>
                    </>
                  )}
                </div>
              </Dialog>

              {/* Diálogo para motivo de rechazo */}
              <Dialog
                header="Motivo del Rechazo"
                visible={showRechazarDialog}
                style={{ width: '450px' }}
                modal
                onHide={cancelarRechazo}
                footer={
                  <div>
                    <Button
                      label="Cancelar"
                      icon="pi pi-times"
                      className="p-button p-button-rounded p-button-outlined"
                      onClick={cancelarRechazo}
                    />
                    <Button
                      label="Confirmar Rechazo"
                      icon="pi pi-check"
                      className="p-button-primary p-button-rounded p-button"
                      onClick={confirmarRechazo}
                      disabled={loading}
                      raised
                    />
                  </div>
                }
              >
                <div className="p-fluid">
                  <label htmlFor="observacion">Seleccione el motivo del rechazo:</label>
                  <Dropdown
                    id="observacion"
                    value={observacion}
                    options={motivosRechazo}
                    onChange={(e) => setObservacion(e.value)}
                    optionLabel="label"
                    placeholder="Seleccione un motivo de rechazo..."
                    className="w-full"
                    required
                  />
                </div>
              </Dialog>

              {/* Diálogo para seleccionar la fecha de vencimiento */}
              <Dialog
                header={`Vencimiento de la Cotización N°${idCotizacion}`}
                visible={showVencimientoDialog}
                style={{ width: '450px' }}
                modal
                onHide={cancelarVencimiento}
                footer={
                  <div>
                    <Button
                      label="Cancelar"
                      icon="pi pi-times"
                      className="p-button p-button-rounded p-button-outlined"
                      onClick={cancelarVencimiento}
                    />
                    <Button
                      label="Confirmar"
                      icon="pi pi-check"
                      className="p-button-success p-button-rounded p-button"
                      onClick={confirmarVencimiento}
                      disabled={loading || !fechaVencimiento}
                      raised
                    />
                  </div>
                }
              >
                <span className="p-float-label mt-1">
                  <Calendar
                    id="fechaVencimiento"
                    value={fechaVencimiento}
                    onChange={(e) => setFechaVencimiento(e.value)}
                    dateFormat="dd/mm/yy"
                    placeholder="Seleccione"
                    required
                    minDate={new Date()}
                    className="p-input-lg w-full"
                    width="10px"
                  />
                  <label htmlFor="fechaVencimiento"><i className="pi pi-calendar"></i>  Fecha de Vencimiento:</label>
                </span>
              </Dialog>
              {/* Diálogo para renovar la asignación */}
              <RenovarAsignacionDialog visible={showRenovarDialog} onHide={cancelarRenovacion} idCotizacion={idCotizacion} idCliente={idCliente} desde={desde} hasta={hasta} motivosOptions={motivosRenovacion} />
            </>
          </div>
        {/* </>
      )} */}
    </>
  );
};

export default RevisarCotizacion;